 /**
 * @name InfoBox
 * @version 1.1.13 [March 19, 2014]
 * @author Gary Little (inspired by proof-of-concept code from Pamela Fox of Google)
 * @copyright Copyright 2010 Gary Little [gary at luxcentral.com]
 * @fileoverview InfoBox extends the Google Maps JavaScript API V3 <tt>OverlayView</tt> class.
 *  <p>
 *  An InfoBox behaves like a <tt>google.maps.InfoWindow</tt>, but it supports several
 *  additional properties for advanced styling. An InfoBox can also be used as a map label.
 *  <p>
 *  An InfoBox also fires the same events as a <tt>google.maps.InfoWindow</tt>.
 */

/*!
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/*jslint browser:true */
/*global google */

/**
 * @name InfoBoxOptions
 * @class This class represents the optional parameter passed to the {@link InfoBox} constructor.
 * @property {string|Node} content The content of the InfoBox (plain text or an HTML DOM node).
 * @property {boolean} [disableAutoPan=false] Disable auto-pan on <tt>open</tt>.
 * @property {number} maxWidth The maximum width (in pixels) of the InfoBox. Set to 0 if no maximum.
 * @property {Size} pixelOffset The offset (in pixels) from the top left corner of the InfoBox
 *  (or the bottom left corner if the <code>alignBottom</code> property is <code>true</code>)
 *  to the map pixel corresponding to <tt>position</tt>.
 * @property {LatLng} position The geographic location at which to display the InfoBox.
 * @property {number} zIndex The CSS z-index style value for the InfoBox.
 *  Note: This value overrides a zIndex setting specified in the <tt>boxStyle</tt> property.
 * @property {string} [boxClass="infoBox"] The name of the CSS class defining the styles for the InfoBox container.
 * @property {Object} [boxStyle] An object literal whose properties define specific CSS
 *  style values to be applied to the InfoBox. Style values defined here override those that may
 *  be defined in the <code>boxClass</code> style sheet. If this property is changed after the
 *  InfoBox has been created, all previously set styles (except those defined in the style sheet)
 *  are removed from the InfoBox before the new style values are applied.
 * @property {string} closeBoxMargin The CSS margin style value for the close box.
 *  The default is "2px" (a 2-pixel margin on all sides).
 * @property {string} closeBoxURL The URL of the image representing the close box.
 *  Note: The default is the URL for Google's standard close box.
 *  Set this property to "" if no close box is required.
 * @property {Size} infoBoxClearance Minimum offset (in pixels) from the InfoBox to the
 *  map edge after an auto-pan.
 * @property {boolean} [isHidden=false] Hide the InfoBox on <tt>open</tt>.
 *  [Deprecated in favor of the <tt>visible</tt> property.]
 * @property {boolean} [visible=true] Show the InfoBox on <tt>open</tt>.
 * @property {boolean} alignBottom Align the bottom left corner of the InfoBox to the <code>position</code>
 *  location (default is <tt>false</tt> which means that the top left corner of the InfoBox is aligned).
 * @property {string} pane The pane where the InfoBox is to appear (default is "floatPane").
 *  Set the pane to "mapPane" if the InfoBox is being used as a map label.
 *  Valid pane names are the property names for the <tt>google.maps.MapPanes</tt> object.
 * @property {boolean} enableEventPropagation Propagate mousedown, mousemove, mouseover, mouseout,
 *  mouseup, click, dblclick, touchstart, touchend, touchmove, and contextmenu events in the InfoBox
 *  (default is <tt>false</tt> to mimic the behavior of a <tt>google.maps.InfoWindow</tt>). Set
 *  this property to <tt>true</tt> if the InfoBox is being used as a map label.
 */

$(document).ready(function() {
	if($('.GPC0102').length == 0) return false;
	var $cont = $('.GPC0102');
	
	/* LGCOMSPEED-11 Start */
	if(!!document.querySelector('.GPC0102 .lazylaod-js')){
		var lazyJsObserver = new IntersectionObserver(function(entries, observer){
			entries.forEach(function(lazyJs){
				if(lazyJs.isIntersecting){
					console.log(lazyJs);
					let attr = lazyJs.target.dataset.lazyloadAttr;
					console.log(attr);
					var d = document,
					s = d.createElement('script');
					attr.split(' ').forEach(function(item){
						if (item.indexOf('=') > -1) {
							var test  = item.split('=');
							s.setAttribute(test[0], test[1].replace(/\"/gi, ""));
						} else {
							s.setAttribute(item, '');
						}
						
					});
					lazyJs.target.after(s);
					lazyJsObserver.unobserve(lazyJs.target);
				}
			});
		});
		lazyJsObserver.observe(document.querySelector('.GPC0102 .lazylaod-js'));
	}
	/* LGCOMSPEED-11 End */

	// iframe
	if($cont.find('.box-3rd-party').length>0) {
		$cont.find('.box-3rd-party').each(function() {
			var obj = $(this);
			if(obj.find('.list-commerce-connector').length>0 && obj.find('.list-commerce-connector .commerce-connector-js').length>0) {
				if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
					// save the script code
					obj.data('template', $(this).find('.list-commerce-connector').html());
					var jsHTML = obj.data('template');
					var jsLink = $(jsHTML).data('src');
					var dataList = $(jsHTML).data();
					var tmpJS = document.createElement('script');
					tmpJS.src = jsLink;
					for(var key in dataList) {
						if(key!='src') {
							tmpJS.setAttribute('data-'+key, dataList[key]);
						}
					}
					var mapFlag = false;
					$(window).scroll(function() {
						var t= obj.eq(0).offset().top;
						var b= t + obj.eq(0).height();
						if(isInScreen(t, b)) {
							if(!mapFlag) {
								mapFlag = true;
								obj.find('.list-commerce-connector').html($(tmpJS));
							}
						}
					});
				} else {
					ePrivacyCookies.view('load', '', obj);
				}
			} else if($cont.find('.lazyload-iframe').length>0) {
				$cont.find('.lazyload-iframe').each(function() {
					var obj2 = $(this);
					if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
						var mapFlag = false;
						$(window).scroll(function() {
							var t= obj2.eq(0).offset().top;
							var b= t + obj2.eq(0).height();
							if(isInScreen(t, b)) {
								if(!mapFlag) {
									mapFlag = true;
									obj2.attr('src', obj2.attr('data-src')).removeAttr('data-src');
								}
							}
						});
					} else {
						ePrivacyCookies.view('load', '', obj);
					}
				});
			} else if($cont.find('.lazyLoadedIframe').length>0) {
				$cont.find('.lazyLoadedIframe').each(function() {
					var obj3 = $(this);
					if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
						$(window).scroll(function() {
							var t= obj3.eq(0).offset().top;
							var b= t + obj3.eq(0).height();
							if(isInScreen(t, b)) {
								if(!mapFlag) {
									mapFlag = true;
									obj3.attr('src', obj3.attr('data-src')).removeAttr('data-src');
								}
							}
						});
					} else {
						ePrivacyCookies.view('load', '', obj);
					}
				});
			}
		});
	}
	/* LGEIS-138 add */
	if($cont.find('.directFrom').length > 0){
		$cont.find('.directFrom .img-thumb').append('<img src="'+$('.GPC0009 img#base_detail_target').attr('data-src')+'" alt="'+$('.GPC0009 img#base_detail_target').attr('alt')+'"/>');
		
		/* LGEITF-629, LGEITF-604, LGCOMSPEED-6 start*/
		/*setTimeout(function() {
			$cont.find('.directFrom .price-area').append($('.GPC0009 .price-area').html()); //시점차 발생으로 인해 GPC0009로 이동
		}, 1500);*/
		/*if($('.GPC0009 .desktop-info .member-price').length > 0){
			$cont.find('.directFrom .price-area').append($('.GPC0009 .desktop-info .member-price').clone()); //PJTMEMBERSHIP-8 add
		}*/
		/* LGEITF-629, LGEITF-604, LGCOMSPEED-6 end*/
		
		if ($('.GPC0009').length ) {
			var energyLabelFlag = $("#energyLabelFlag").val();
			var productFicheFileName = $("#productFicheFileName").val();
			var productFicheOriginalName = $("#productFicheOriginalName").val();
			var energyLabel = $("#energyLabel").val();
			var energyLabelDocId = $("#energyLabelDocId").val();
			var energyLabelFileName = $("#energyLabelFileName").val();
			var productFicheDocId = $("#productFicheDocId").val();
			var energyLabelOriginalName = $("#energyLabelOriginalName").val();
			var pdfDownloadFile = $("#pdfDownloadFile").val();
			var productFicheDownload = $("#productFicheDownload").val();
			var energyLabelImageAddr = $("#energyLabelImageAddr").val();
			var energyLabelName = $("#energyLabelName").val();
			var filelist = $cont.find(".file-list");
	        if(energyLabelFlag == 'Y'){
	        	var html = "";
	        	if( productFicheFileName !="" && productFicheOriginalName !="" && productFicheFileName != null && productFicheOriginalName !=null && productFicheDocId !=null && productFicheDocId !=""){
	        	 html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+ productFicheDocId +"' data-file='" + productFicheFileName + "' data-original='" + productFicheOriginalName + "' data-category='' class='link-text' title='" + pdfDownloadFile + "'>"
	        			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
	        			+ "</a>";
	        	}
	        	if(energyLabel != "" && energyLabel != "N" && energyLabel != null && energyLabelFileName !=null && energyLabelFileName != "" && energyLabelOriginalName != null && energyLabelOriginalName !="" && energyLabelName != null
	        			&& energyLabelName !="" && energyLabelImageAddr != null && energyLabelImageAddr !=""  ){
	        		html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + energyLabelDocId + "' data-file='" + energyLabelFileName + "' data-original='" + energyLabelOriginalName + "'  data-category='' class='link-text' title='" + pdfDownloadFile + "'>"
	    	        + "<span class='label type-none'>";
	        	 html += "<img src='" + energyLabelImageAddr + "' alt='" +energyLabelName + "'>";
	        	
	        	html += "</span></a>";
	        	
	        	}
	        	filelist.html(html);
			}
			//LGEFR-640
			var labelUseFlag = $('#labelUseFlag').val();
			var repairabilityIndexFlag = $('#repairabilityIndexFlag').val();
			var repairLinkUrl = $('#repairLinkUrl').val();
			var repairLinkOpt = $('#repairLinkOpt').val();
			var repairImagePathAddr = $('#repairImagePathAddr').val();
			var repairAltText = $('#repairAltText').val();
			
			var repairAbilityArea = $cont.find(".repairability-index");
			var repairabilityMsg = repairAbilityArea.attr('data-repairability-msg');
			var targetBlankMsg = repairAbilityArea.attr('data-target-blank-msg');
			
			if(labelUseFlag == 'Y' && repairabilityIndexFlag == 'Y'){
				var repairAbilityHtml  = "<div class='score'>";
				    repairAbilityHtml  += "<span class='txt'>"+repairabilityMsg+"</span>";
				if(repairLinkUrl != 'null' && repairLinkUrl != ''){
					repairAbilityHtml  += "<a href='"+repairLinkUrl+"'";
					if(repairLinkOpt =='S'){
						repairAbilityHtml  += " target='_self'";
					}else if(repairLinkOpt =='B'){
						repairAbilityHtml  += " target='_blank'";
					}
					repairAbilityHtml  += " title='"+targetBlankMsg+"' class='link-pdf'>";
				}else{
                    repairAbilityHtml += "<span class='link-pdf'>";
                }
				if(repairImagePathAddr != 'null' && repairImagePathAddr != ''){
					repairAbilityHtml  += "<img src='"+repairImagePathAddr+"' alt='"+repairAltText+"' area-hidden='true' />";
				}
				if(repairLinkUrl != 'null' && repairLinkUrl != ''){
					repairAbilityHtml  += "</a></div>";
				}else{
                    repairAbilityHtml  += "</span></div>";
                }
				repairAbilityArea.html(repairAbilityHtml);
			} 
			//LGEFR-640 
		}
		var fileDownload = function($link) {
			if($('form#formDown').length>0) $('form#formDown').remove();

			var fileBox = $link.closest('[data-file-download]');
			var flag = fileBox.data('flag').toUpperCase();
			var downtime = fileBox.data('downtime') || null;
			var opentime = fileBox.data('opentime') || null;

			if(flag=='Y') {
				// downtime error
				var $errorPop = $('#htmlOpenError');
				if($errorPop.length>0) {
					$errorPop.modal();
					$errorPop.find('.htmldowntime').text(downtime);
					$errorPop.find('.htmlopentime').text(opentime);
				} else {
					console.log('#htmlOpenError is required in HTML');
				}
			} else {

				var doc = $link.data('doc'),
					file = $link.data('file'),
					original = $link.data('original'),
					category = $link.data('category');
				var input = '<input type="hidden" id="DOC_ID" name="DOC_ID" value="' + doc +'" />';
				input += '<input type="hidden" id="ORIGINAL_NAME_b1_a1" name="ORIGINAL_NAME_b1_a1" value="' + original +'" />';
				input += '<input type="hidden" id="FILE_NAME" name="FILE_NAME" value="' + file +'" />';
				input += '<input type="hidden" id="TC" name="TC" value="DwnCmd" />';
				input += '<input type="hidden" id="GSRI_DOC" name="GSRI_DOC" value="GSRI" />';

				var form = $('<form />').attr({
					id: 'formDown',
					method: 'get',
					action: fileBox.data('action'),
					target: '_self'
				}).append(input);
				$('body').append(form);

				$('#formDown').submit();
			}
		}
		$cont.find('.file-list a.link-text').on('click', function(e) {
			e.preventDefault();
			fileDownload($(this));
		});
	}
	/*//LGEIS-138 add */

	// find-online
	if($cont.find('.find-online').length > 0) {

		var changeHTML = function(displayType, data, template, i) {
			if(!template) return '';
			// 20200416 START 박지영 UA 버전 추가
			if(displayType=='ru' || displayType=='ua') {
			// 20200416 END
				var cid = decodeURI(getCookie('cid'));
				txt = template.replace(/\*url1\*/g, (!!getCookie('cid')) ? data.purchase_link+'&cid='+cid : data.purchase_link)
						.replace(/\*url2\*/g,  (!!getCookie('cid')) ? data.purchase_link+'&cid='+cid : data.purchase_link)
						.replace(/\*url\*/g,  (!!getCookie('cid')) ? data.purchase_link+'&cid='+cid : data.purchase_link)
						.replace(/\*img\*/g, data.logo)
						.replace(/\*txt\*/g, data.name)
						.replace(/\*idx\*/g, i)
						;
			} else if(displayType=='lg') {
				txt = template.replace(/\*url1\*/g, data.deeplink_url)
						.replace(/\*url2\*/g,  data.deeplink_url)
						.replace(/\*url\*/g,  data.deeplink_url)
						.replace(/\*img\*/g, data.logo_url)
						.replace(/\*txt\*/g, data.name)
						.replace(/\*idx\*/g, i)
						;
			} else if($('html').data('countrycode') == 'br') {
				//LGEBR-37
				//LGEBR-571 start
				/*
				console.log('GPC0102 data.url = ' + data.url);
				console.log('GPC0102 data.available = ' + data.available);
				console.log('GPC0114 availableTrueText = ' + $('input[name=availableTrueText]').val());
				console.log('GPC0114 availableTrueBtnName = ' + $('input[name=availableTrueBtnName]').val());
				console.log('GPC0114 availableFalseText = ' + $('input[name=availableFalseText]').val());
				console.log('GPC0114 availableFalseBtnName = ' + $('input[name=availableFalseBtnName]').val());
				*/
				if (data.available) {
					txt = template.replace(/\*url1\*/g, data.url)
					  .replace(/\*url2\*/g,  data.url)
					  .replace(/\*url\*/g,  data.url)
					  .replace(/\*img\*/g, data.retailerLogo)
					  .replace(/\*txt\*/g, data.retailer)
					  .replace(/\*available\*/g, data.available)
					  .replace(/\*available_message\*/g, $('input[name=availableTrueText]').val())
					  .replace(/\*available_btn_name\*/g, $('input[name=availableTrueBtnName]').val())
					  .replace(/\*available_btn_type\*/g, 'btn-primary')
					  .replace(/\*idx\*/g, i)
					  ;
				} else {
					txt = template.replace(/\*url1\*/g, data.url)
					  .replace(/\*url2\*/g,  data.url)
					  .replace(/\*url\*/g,  data.url)
					  .replace(/\*img\*/g, data.retailerLogo)
					  .replace(/\*txt\*/g, data.retailer)
					  .replace(/\*available\*/g, data.available)
					  .replace(/\*available_message\*/g, $('input[name=availableFalseText]').val())
					  .replace(/\*available_btn_name\*/g, $('input[name=availableFalseBtnName]').val())
					  .replace(/\*available_btn_type\*/g, 'btn-outline-primary')
					  .replace(/\*idx\*/g, i)
					  ;
				}
				//LGEBR-571 end
				/*LGETR-264 add*/
			} else if(displayType=='lgtrdata') {
				console.log(data)
				txt = template.replace(/\*url\*/g,  data.url)
						.replace(/\*img\*/g, data.logo)
						.replace(/\*txt\*/g, data.name)
						.replace(/\*idx\*/g, i)
						;
				/*//LGETR-264 add*/
			} else {
				txt = template.replace(/\*url1\*/g, (data.homepage_url ? data.homepage_url : data.deeplink_url))
						.replace(/\*url2\*/g,  (data.deeplink_url ? data.deeplink_url : data.homepage_url))
						.replace(/\*url\*/g,  (data.deeplink_url ? data.deeplink_url : data.homepage_url))
						.replace(/\*img\*/g, data.logo_url)
						.replace(/\*txt\*/g, (displayType) ? data.display_name : data.name)
						.replace(/\*idx\*/g, i)
						;
			}
			return txt;
		};

		// eprivacy
		$cont.find('.find-online .list').each(function() {
			var obj = $(this);
			// 20200311 START 박지영 - online 쿠키 배너 체크 해제 
			if(obj.hasClass('stock-list-ajax')) {
				// 3rd party (GPC0009, GPC0102, GPC0114)
				//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
					obj.addClass('active');
					var _this = $(this);
					// 20200416 START 박지영 UA 버전 추가
					var url = _this.data('url') || _this.data('url-pattern');					
					// 20200416 END
					var template = _this.find('template').clone().html();
					var isDisplayName = _this.data("display-name");

					var dataType = 'json';
					var res = 'retailers';
					if(url.indexOf('lgwtb.lv') >=0) {
						dataType = 'jsonp';
						res = 'shops'
					}
					/*LGETR-264 add*/
					if(isDisplayName =='lgtrdata') {
						res = 'lgtrdata'
					}
					/*//LGETR-264 add*/
					// 20200416 START 박지영 UA 버전 추가
					var shuffleArray = function (array) {
						for (var i = 0; i < array.length; i++) {
							var j = Math.floor(Math.random() * (i + 1));
							var temp = array[i];
							array[i] = array[j];
							array[j] = temp;
						}
						return array;
					}

					if(url.indexOf('*BU*') >= 0) {
						url = url.replace('\*BU\*', getBU('online'));
						_this.data('template', template);
						_this.find('template').remove();
						var mpn = _this.attr('data-mpn');
						ajax.call(url, {region: 'ua', mpn: mpn, callback: "success"}, 'jsonp', function(data){
							if(_this.find('.list-box .items').hasClass('slick-initialized')) {
								_this.find('.list-box .items').slick('unslick').empty();
							}
							// 아래 내용 수정 시, (GPC0112, GPC0114) 함께 수정 필요
							var html = '';
							if(data && data.iceleads_interface.status === 200) {
								if(data.iceleads_interface.retailers.retailer.length==0) {
									_this.find('ul').remove();
									_this.append('<ul>'+xssfilter(html, 'html')+'</ul>');
									_this.find('.no-items').removeClass('active');
								} else {
									var shops = shuffleArray(data.iceleads_interface.retailers.retailer),
										html = '';
									for (var i = 0; i < shops.length; i++) {
										if ((shops[i].stock_qty > 0) || (shops[i].stock_qty == "-99")) {
											html = changeHTML('ua', shops[i], _this.data('template'), i) + html;
										}
									}
									if(html!='') {
										_this.find('ul').remove();
										_this.append('<ul>'+xssfilter(html, 'html')+'</ul>');
										_this.find('.no-items').removeClass('active');
									} else {
										_this.find('ul').remove();
										_this.find('.no-items').addClass('active');
										/* LGEGMC-524 : 20200908 add */
										if(!!!$('#pdpOfflieWhere').length){
											$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
											$('.GPC0011 a[href="#pdp_where"]').parent().remove();
										}								
										/*// LGEGMC-524 : 20200908 add */
									}
								}
							} else {
								_this.find('ul').remove();
								_this.find('.no-items').addClass('active');
								/* LGEGMC-524 : 20200908 add */
								if(!!!$('#pdpOfflieWhere').length){
									$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
									$('.GPC0011 a[href="#pdp_where"]').parent().remove();
								}								
								/*// LGEGMC-524 : 20200908 add */
							}
						}, 'get', null);
					} else if(COUNTRY_CODE == 'br'){
							//LGEBR-37, LGEBR-501
							
							$cont.append('<div class="loading-circle"><div class="lds-dual-ring"></div></div>');
							$.ajax({
								type: 'GET',
							    url: url,
							    timeout: 20000,
							    dataType: "json",
							    success: function(result) { 
							    	
							    	if(result.status == 200 && result.status != undefined){
										_this.data('template', template);
										_this.find('template').remove();
										/* LGEBR-1126 start*/
										if(result.data !== undefined){
											var items = result.data.offers;
								    		var r = items;
								    		var html = '';
								    		if(r.length>0) {
												for(i=0;i<r.length;i++) {
													if(r[i].available != 'false') {
														html = html + changeHTML(isDisplayName, r[i], _this.data('template'), i);
													}
												}
												if(html!='') {
													_this.find('ul').remove();
													_this.append('<ul>'+xssfilter(html, 'html')+'</ul>');
													_this.find('.no-items').removeClass('active');
												} else {
													_this.find('ul').remove();
													_this.find('.no-items').addClass('active');
													/* LGEGMC-524 : 20200908 add */
													if(!!!$('#pdpOfflieWhere').length){
														$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
														$('.GPC0011 a[href="#pdp_where"]').parent().remove();
													}								
													/*// LGEGMC-524 : 20200908 add */
												}
												$cont.find('.loading-circle').remove();
											} else {
												_this.find('ul').remove();
												_this.find('.no-items').addClass('active');
												$cont.find('.loading-circle').remove();
												/* LGEGMC-524 : 20200908 add */
												if(!!!$('#pdpOfflieWhere').length){
													$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
													$('.GPC0011 a[href="#pdp_where"]').parent().remove();
												}								
												/*// LGEGMC-524 : 20200908 add */
											}
										}else{
											_this.find('ul').remove();
											_this.find('.no-items').addClass('active');
											$cont.find('.loading-circle').remove();
											/* LGEGMC-524 : 20200908 add */
											if(!!!$('#pdpOfflieWhere').length){
												$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
												$('.GPC0011 a[href="#pdp_where"]').parent().remove();
											}								
											/*// LGEGMC-524 : 20200908 add */
										}
										/* LGEBR-1126 end*/
							    	} else {
										_this.find('ul').remove();
										_this.find('.no-items').addClass('active');
										$cont.find('.loading-circle').remove();
										/* LGEGMC-524 : 20200908 add */
										if(!!!$('#pdpOfflieWhere').length){
											$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
											$('.GPC0011 a[href="#pdp_where"]').parent().remove();
										}								
										/*// LGEGMC-524 : 20200908 add */
							    	}
							    
							    	
							    },
							    error: function(request, status, error) {
							    	console.log("error!");
							    	_this.find('ul').remove();
									_this.find('.no-items').addClass('active');
									$cont.find('.loading-circle').remove();
									if(!!!$('#pdpOfflieWhere').length){
										$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
										$('.GPC0011 a[href="#pdp_where"]').parent().remove();
									}
								}
									});
						
					} else {
						_this.data('template', template);
						_this.find('template').remove();
						// 20200316 START 박지영 - dataType 미반영된것 반영
						ajax.call(url, {}, dataType, function(data){
						// 20200316 END
							var html = '';
							if(data) {
								// 아래 내용 수정 시, (GPC0009, GPC0102, GPC0114) 함께 수정 필요
								// GPC0009 클릭시 GPC0102 수정됨
								var r = '';
								/*LGETR-264 modify*/
								if(res == 'retailers') {
									// Channel Advisor, Intellibrand
									r = data.products[0].retailers;
								}else if(isDisplayName == 'lgtrdata'){
									r = data.retailers;
								} else {
									// lgwtb.lv (ee, lt, lv)
									r = data.shops;
								}
								if((res !== 'lgtrdata' && r.length>0) || (res == 'lgtrdata' && data.result>0)) {
									for(i=0;i<r.length;i++) {
										if(data.products && data.products[0].model_code) _this.attr('data-model', data.products[0].model_code);
										if(r[i].instock != 'false' && isDisplayName !== 'lgtrdata') {
											html = html + changeHTML(isDisplayName, r[i], _this.data('template'), i);
										}else if(isDisplayName == 'lgtrdata') {
											if(r[i].availability != 0) {
												html = html + changeHTML(isDisplayName, r[i], _this.data('template'), i);
											}
										}else if(COUNTRY_CODE == 'gr') {
											html = html + changeHTML(isDisplayName, r[i], _this.data('template'), i);
										}
									}
									if(html!='') {
										_this.find('ul').remove();
										_this.append('<ul>'+xssfilter(html, 'html')+'</ul>');
										_this.find('.no-items').removeClass('active');
									} else {
										_this.find('ul').remove();
										_this.find('.no-items').addClass('active');
										/* LGEGMC-524 : 20200908 add */
										if(!!!$('#pdpOfflieWhere').length){
											$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
											$('.GPC0011 a[href="#pdp_where"]').parent().remove();
										}								
										/*// LGEGMC-524 : 20200908 add */
									}
								} else {
									_this.find('ul').remove();
									_this.find('.no-items').addClass('active');
									/* LGEGMC-524 : 20200908 add */
									if(!!!$('#pdpOfflieWhere').length){
										$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
										$('.GPC0011 a[href="#pdp_where"]').parent().remove();
									}								
									/*// LGEGMC-524 : 20200908 add */
								}

							} else {
								// error
								_this.find('ul').remove();
								_this.find('.no-items').addClass('active');
								/* LGEGMC-524 : 20200908 add */
								if(!!!$('#pdpOfflieWhere').length){
									$('.GPC0009 .button .where-to-buy[href="#pdp_where"]').remove();
									$('.GPC0011 a[href="#pdp_where"]').parent().remove();
								}								
								/*// LGEGMC-524 : 20200908 add */
							}
						}, 'get', null);
					}
					// 20200416 END
				//} else {
				//	ePrivacyCookies.view('load', '', obj);
				//	obj.addClass('active');
				//}
			} else {
				//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
					obj.addClass('active');
				//} else {
				//	ePrivacyCookies.view('load', '', obj);
				//	obj.addClass('active');
				//}
			}
			// 20200311 END
		});
		
		// mouse, focus
			$cont.find('.find-online').on('mouseenter', '.list ul li', function() {
				$(this).closest('li').addClass('over');
			}).on('mouseleave', '.list ul li', function() {
				$(this).closest('li').removeClass('over');
			});
			$cont.find('.find-online').on('focus', '.list ul li a', function() {
				$(this).closest('li').addClass('over');
			}).on('blur', '.list ul li a', function() {
				$(this).closest('li').removeClass('over');
			});

		// load more for mobile device
			$cont.find('.find-online .btn-wrap a.btn').on('click', function(e) {
				e.preventDefault();
				var idx = $(this).closest('.find-online').find('.list ul li.mobile-hidden').index();
				for(var i=0;i<8;i++) { // 1page=8
					$(this).closest('.find-online').find('.list ul li').eq(i+idx).removeClass('mobile-hidden');
				}
				if ($(this).closest('.find-online').find('.list ul li.mobile-hidden').length == 0) {
					$(this).closest('.btn-wrap').removeClass('active');
				}
			});
	
		/*
		// ES : 클릭시 gtm 처리 (GPC0009, GPC0102, GPC0114) 
		// 5.0에서는 아래 category를 받아올 방법이 없어서  LGEES-2387 은 일단 홀딩 합니다. 추후 법인 요청시 요건 재확인 후 처리 예정
		if($('html').data('countrycode') == 'es') {
			$('.GPC0102 .stock-list-ajax').on('click', 'ul li a', function(e) {
				e.preventDefault();
				var cont = $(this).closest('.stock-list-ajax');
				var theModelNo = cont.attr("data-model"); //Model name
				var theRetailer = $(this).parents("li").find('.visual-area img').attr("alt"); //retailer name
				//var theCategory = $("html").attr("data-compare-category"); //Category name

				//_gaq.push(['_trackEvent', theRetailer, theCategory , theModelNo ]);
				ga('create', 'UA-36685433-1', 'auto');
				ga('send', 'event', theRetailer, theCategory, theModelNo);

				window.open(_this.attr("href"));
			});
		}
		*/
	}

	// LGECN-97 Start
	// find-online-cn
	if($cont.find('.find-online-cn').length > 0) {

		var changeHTML = function(data, template) {
			// 20200513 START 박지영 - json 구조 변경
			txt = template.replace(/\*siteName\*/g, data.siteName)
					.replace(/\*imageAddr\*/g,  data.imageAddr)
					.replace(/\*link\*/g, data.link)
					;
			// 20200513 END
			//console.log(txt);
			return txt;
		};

		// eprivacy
		var obj = $cont.find('.find-online-cn form');
		var list = obj.closest('.find-online-cn').find('.list');
		var template = list.find('template').clone().html();
		list.find('template').remove();
		function getOnlineRetailer() {
			if(list.length>0) {
				if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE')) {
					list.addClass('active');
					var url = obj.attr('action');
					ajax.call(url, obj.serialize(), 'json', function(data){
						if(data) {
							var html = '';
							if(data.data.length==0) {
								// 20200514 START 박지영
								if(list.find('ul').length>0) list.find('ul').hide();
								// 20200514 END
								list.find('.no-items').addClass('active');
								list.parent().find('.btn-wrap').removeClass('active');
							} else {
								for(i=0;i<data.data.length;i++) {
									var tmp = changeHTML(data.data[i], template);
									if(i>=8) tmp = tmp.replace('<li>', '<li class="mobile-hidden">');
									html = html + tmp;
								}
								if(data.data.length>8) {
									list.parent().find('.btn-wrap').addClass('active');
								} else {
									list.parent().find('.btn-wrap').removeClass('active');
								}
								if(html!='') {
									// 20200514 START 박지영
									//list.html('<ul>'+xssfilter(html, 'html')+'</ul>');
									if(list.find('ul').length>0) list.find('ul').show().html(xssfilter(html, 'html'));
									else list.prepend('<ul>'+xssfilter(html, 'html')+'</ul>');
									list.find('.no-items').removeClass('active');
									// 20200514 END
								} else {
									list.find('.no-items').addClass('active');
									list.parent().find('.btn-wrap').removeClass('active');
								}
							}
						} else {
							list.find('.no-items').addClass('active');
							list.parent().find('.btn-wrap').removeClass('active');
						}
					}, 'post', null);
				} else {
					$cont.find('.find-online-cn .searchbox-wrap').remove();
					ePrivacyCookies.view('load', '', list);
					list.addClass('active');
				}
			} else {
				if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
					obj.addClass('active');
				} else {
					$cont.find('.find-online-cn .searchbox-wrap').remove();
					ePrivacyCookies.view('load', '', list);
					list.addClass('active');
				}
			}
		}
		getOnlineRetailer();
		// change combo box
		$cont.find('#onlineCity').on('change', function() {
			getOnlineRetailer();
		});
		
		// mouse, focus
			$cont.find('.find-online-cn').on('mouseenter', '.list ul li', function() {
				$(this).closest('li').addClass('over');
			}).on('mouseleave', '.list ul li', function() {
				$(this).closest('li').removeClass('over');
			});
			$cont.find('.find-online-cn').on('focus', '.list ul li a', function() {
				$(this).closest('li').addClass('over');
			}).on('blur', '.list ul li a', function() {
				$(this).closest('li').removeClass('over');
			});

		// load more for mobile device
			$cont.find('.find-online-cn .btn-wrap a.btn').on('click', function(e) {
				e.preventDefault();
				var idx = $(this).closest('.find-online-cn').find('.list ul li.mobile-hidden').index();
				for(var i=0;i<8;i++) { // 1page=8
					$(this).closest('.find-online-cn').find('.list ul li').eq(i+idx).removeClass('mobile-hidden');
				}
				if ($(this).closest('.find-online-cn').find('.list ul li.mobile-hidden').length == 0) {
					$(this).closest('.btn-wrap').removeClass('active');
				}
			});
	}
	// LGECN-97 End

	// find-locally
	if($cont.find('.find-locally').length > 0) {

		// eprivacy
		$cont.find('.find-locally').each(function() {
			var obj = $(this).find('.map-container');
			//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
			//LGEAE-306/LGEAF-114/LGEJO-107/LGEAF-136 Start
			if($cont.find('#multiBrandShopImprovingFlag').val() == 'Y') {
				obj.closest('.find-locally').addClass('has-search has-category');
			}
			//LGEAE-306/LGEAF-114/LGEJO-107/LGEAF-136 End
				obj.closest('.find-locally').addClass('active');
			//} else {
			//	obj.parent().find('.searchbox-wrap').remove();
			//	obj.parent().find('.search-results').remove();
			//	ePrivacyCookies.view('load', '', obj);
			//	obj.css('background', '#fff');
			//	obj.closest('.find-locally').addClass('active');
			//	return false;
			//}
		});

		// google map
		window.initialize = function() {

			// infoBox
			{
				function InfoBox(opt_opts) {
					opt_opts = opt_opts || {};
					google.maps.OverlayView.apply(this, arguments);
					// Standard options (in common with google.maps.InfoWindow):
					//
					this.content_ = opt_opts.content || "";
					this.disableAutoPan_ = opt_opts.disableAutoPan || false;
					this.maxWidth_ = opt_opts.maxWidth || 0;
					this.pixelOffset_ = opt_opts.pixelOffset || new google.maps.Size(0, 0);
					this.position_ = opt_opts.position || new google.maps.LatLng(0, 0);
					this.zIndex_ = opt_opts.zIndex || null;

					// Additional options (unique to InfoBox):
					//
					this.boxClass_ = opt_opts.boxClass || "infoBox";
					this.boxStyle_ = opt_opts.boxStyle || {};
					this.closeBoxMargin_ = opt_opts.closeBoxMargin || "2px";
					this.closeBoxURL_ = opt_opts.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif";
					if (opt_opts.closeBoxURL === "") {
						this.closeBoxURL_ = "";
					}
					this.infoBoxClearance_ = opt_opts.infoBoxClearance || new google.maps.Size(1, 1);

					if (typeof opt_opts.visible === "undefined") {
						if (typeof opt_opts.isHidden === "undefined") {
							opt_opts.visible = true;
						} else {
							opt_opts.visible = !opt_opts.isHidden;
						}
					}
					this.isHidden_ = !opt_opts.visible;

					this.alignBottom_ = opt_opts.alignBottom || false;
					this.pane_ = opt_opts.pane || "floatPane";
					this.enableEventPropagation_ = opt_opts.enableEventPropagation || false;

					this.div_ = null;
					this.closeListener_ = null;
					this.moveListener_ = null;
					this.contextListener_ = null;
					this.eventListeners_ = null;
					this.fixedWidthSet_ = null;
				}

				/* InfoBox extends OverlayView in the Google Maps API v3.
				 */
				InfoBox.prototype = new google.maps.OverlayView();

				/**
				 * Creates the DIV representing the InfoBox.
				 * @private
				 */
				InfoBox.prototype.createInfoBoxDiv_ = function() {

					var i;
					var events;
					var bw;
					var me = this;

					// This handler prevents an event in the InfoBox from being passed on to the map.
					//
					var cancelHandler = function(e) {
						e.cancelBubble = true;
						if (e.stopPropagation) {
							e.stopPropagation();
						}
					};

					// This handler ignores the current event in the InfoBox and conditionally prevents
					// the event from being passed on to the map. It is used for the contextmenu event.
					//
					var ignoreHandler = function(e) {

						e.returnValue = false;

						if (e.preventDefault) {

							e.preventDefault();
						}

						if (!me.enableEventPropagation_) {

							cancelHandler(e);
						}
					};

					if (!this.div_) {

						this.div_ = document.createElement("div");

						this.setBoxStyle_();

						if (typeof this.content_.nodeType === "undefined") {
							this.div_.innerHTML = this.getCloseBoxImg_() + this.content_;
						} else {
							this.div_.innerHTML = this.getCloseBoxImg_();
							this.div_.appendChild(this.content_);
						}

						// Add the InfoBox DIV to the DOM
						this.getPanes()[this.pane_].appendChild(this.div_);

						this.addClickHandler_();

						if (this.div_.style.width) {

							this.fixedWidthSet_ = true;

						} else {

							if (this.maxWidth_ !== 0 && this.div_.offsetWidth > this.maxWidth_) {

								this.div_.style.width = this.maxWidth_;
								this.div_.style.overflow = "auto";
								this.fixedWidthSet_ = true;

							} else { // The following code is needed to overcome problems with MSIE

								bw = this.getBoxWidths_();

								this.div_.style.width = (this.div_.offsetWidth - bw.left - bw.right) + "px";
								this.fixedWidthSet_ = false;
							}
						}

						this.panBox_(this.disableAutoPan_);

						if (!this.enableEventPropagation_) {

							this.eventListeners_ = [];

							// Cancel event propagation.
							//
							// Note: mousemove not included (to resolve Issue 152)
							events = ["mousedown", "mouseover", "mouseout", "mouseup",
								"click", "dblclick", "touchstart", "touchend", "touchmove"
							];

							for (i = 0; i < events.length; i++) {

								this.eventListeners_.push(google.maps.event.addDomListener(this.div_, events[i], cancelHandler));
							}

							// Workaround for Google bug that causes the cursor to change to a pointer
							// when the mouse moves over a marker underneath InfoBox.
							this.eventListeners_.push(google.maps.event.addDomListener(this.div_, "mouseover", function(e) {
								this.style.cursor = "default";
							}));
						}

						this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", ignoreHandler);

						/**
						 * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
						 * @name InfoBox#domready
						 * @event
						 */
						google.maps.event.trigger(this, "domready");
					}
				};

				/**
				 * Returns the HTML <IMG> tag for the close box.
				 * @private
				 */
				InfoBox.prototype.getCloseBoxImg_ = function() {

					var img = "";

					if (this.closeBoxURL_ !== "") {

						img = "<a href='#none' class='window-close' id='infoWindowClose'><div class='sr-only'>close</div></a>";
					}

					return img;
				};

				/**
				 * Adds the click handler to the InfoBox close box.
				 * @private
				 */
				InfoBox.prototype.addClickHandler_ = function() {

					var closeBox;

					if (this.closeBoxURL_ !== "") {

						closeBox = this.div_.firstChild;
						this.closeListener_ = google.maps.event.addDomListener(closeBox, "click", this.getCloseClickHandler_());

					} else {

						this.closeListener_ = null;
					}
				};

				/**
				 * Returns the function to call when the user clicks the close box of an InfoBox.
				 * @private
				 */
				InfoBox.prototype.getCloseClickHandler_ = function() {

					var me = this;

					return function(e) {

						// 1.0.3 fix: Always prevent propagation of a close box click to the map:
						e.cancelBubble = true;

						if (e.stopPropagation) {

							e.stopPropagation();
						}

						/**
						 * This event is fired when the InfoBox's close box is clicked.
						 * @name InfoBox#closeclick
						 * @event
						 */
						google.maps.event.trigger(me, "closeclick");

						me.close();
					};
				};

				/**
				 * Pans the map so that the InfoBox appears entirely within the map's visible area.
				 * @private
				 */
				InfoBox.prototype.panBox_ = function(disablePan) {

					var map;
					var bounds;
					var xOffset = 0,
						yOffset = 0;

					if (!disablePan) {

						map = this.getMap();

						if (map instanceof google.maps.Map) { // Only pan if attached to map, not panorama

							if (!map.getBounds().contains(this.position_)) {
								// Marker not in visible area of map, so set center
								// of map to the marker position first.
								map.setCenter(this.position_);
							}

							bounds = map.getBounds();

							var mapDiv = map.getDiv();
							var mapWidth = mapDiv.offsetWidth;
							var mapHeight = mapDiv.offsetHeight;
							var iwOffsetX = this.pixelOffset_.width;
							var iwOffsetY = this.pixelOffset_.height;
							var iwWidth = this.div_.offsetWidth;
							var iwHeight = this.div_.offsetHeight;
							var padX = this.infoBoxClearance_.width;
							var padY = this.infoBoxClearance_.height;
							var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position_);

							if (pixPosition.x < (-iwOffsetX + padX)) {
								xOffset = pixPosition.x + iwOffsetX - padX;
							} else if ((pixPosition.x + iwWidth + iwOffsetX + padX) > mapWidth) {
								xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
							}
							if (this.alignBottom_) {
								if (pixPosition.y < (-iwOffsetY + padY + iwHeight)) {
									yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
								} else if ((pixPosition.y + iwOffsetY + padY) > mapHeight) {
									yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
								}
							} else {
								if (pixPosition.y < (-iwOffsetY + padY)) {
									yOffset = pixPosition.y + iwOffsetY - padY;
								} else if ((pixPosition.y + iwHeight + iwOffsetY + padY) > mapHeight) {
									yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
								}
							}

							if (!(xOffset === 0 && yOffset === 0)) {

								// Move the map to the shifted center.
								//
								var c = map.getCenter();
								map.panBy(xOffset, yOffset);
							}
						}
					}
				};

				/**
				 * Sets the style of the InfoBox by setting the style sheet and applying
				 * other specific styles requested.
				 * @private
				 */
				InfoBox.prototype.setBoxStyle_ = function() {

					var i, boxStyle;

					if (this.div_) {

						// Apply style values from the style sheet defined in the boxClass parameter:
						this.div_.className = this.boxClass_;

						// Clear existing inline style values:
						this.div_.style.cssText = "";

						// Apply style values defined in the boxStyle parameter:
						boxStyle = this.boxStyle_;
						for (i in boxStyle) {

							if (boxStyle.hasOwnProperty(i)) {

								this.div_.style[i] = boxStyle[i];
							}
						}

						// Fix for iOS disappearing InfoBox problem.
						// See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
						this.div_.style.WebkitTransform = "translateZ(0)";

						// Fix up opacity style for benefit of MSIE:
						//
						if (typeof this.div_.style.opacity !== "undefined" && this.div_.style.opacity !== "") {
							// See http://www.quirksmode.org/css/opacity.html
							this.div_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(Opacity=" + (this.div_.style.opacity * 100) + ")\"";
							this.div_.style.filter = "alpha(opacity=" + (this.div_.style.opacity * 100) + ")";
						}

						// Apply required styles:
						//
						this.div_.style.position = "absolute";
						this.div_.style.visibility = 'hidden';
						if (this.zIndex_ !== null) {

							this.div_.style.zIndex = this.zIndex_;
						}
					}
				};

				/**
				 * Get the widths of the borders of the InfoBox.
				 * @private
				 * @return {Object} widths object (top, bottom left, right)
				 */
				InfoBox.prototype.getBoxWidths_ = function() {

					var computedStyle;
					var bw = {
						top: 0,
						bottom: 0,
						left: 0,
						right: 0
					};
					var box = this.div_;

					if (document.defaultView && document.defaultView.getComputedStyle) {

						computedStyle = box.ownerDocument.defaultView.getComputedStyle(box, "");

						if (computedStyle) {

							// The computed styles are always in pixel units (good!)
							bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
							bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
							bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
							bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
						}

					} else if (document.documentElement.currentStyle) { // MSIE

						if (box.currentStyle) {

							// The current styles may not be in pixel units, but assume they are (bad!)
							bw.top = parseInt(box.currentStyle.borderTopWidth, 10) || 0;
							bw.bottom = parseInt(box.currentStyle.borderBottomWidth, 10) || 0;
							bw.left = parseInt(box.currentStyle.borderLeftWidth, 10) || 0;
							bw.right = parseInt(box.currentStyle.borderRightWidth, 10) || 0;
						}
					}

					return bw;
				};

				/**
				 * Invoked when <tt>close</tt> is called. Do not call it directly.
				 */
				InfoBox.prototype.onRemove = function() {

					if (this.div_) {

						this.div_.parentNode.removeChild(this.div_);
						this.div_ = null;
					}
				};

				/**
				 * Draws the InfoBox based on the current map projection and zoom level.
				 */
				InfoBox.prototype.draw = function() {

					this.createInfoBoxDiv_();

					var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position_);

					this.div_.style.left = (pixPosition.x + this.pixelOffset_.width) + "px";

					if (this.alignBottom_) {
						this.div_.style.bottom = -(pixPosition.y + this.pixelOffset_.height) + "px";
					} else {
						this.div_.style.top = (pixPosition.y + this.pixelOffset_.height) + "px";
					}

					if (this.isHidden_) {

						this.div_.style.visibility = "hidden";

					} else {

						this.div_.style.visibility = "visible";
					}
				};

				/**
				 * Sets the options for the InfoBox. Note that changes to the <tt>maxWidth</tt>,
				 *  <tt>closeBoxMargin</tt>, <tt>closeBoxURL</tt>, and <tt>enableEventPropagation</tt>
				 *  properties have no affect until the current InfoBox is <tt>close</tt>d and a new one
				 *  is <tt>open</tt>ed.
				 * @param {InfoBoxOptions} opt_opts
				 */
				InfoBox.prototype.setOptions = function(opt_opts) {
					if (typeof opt_opts.boxClass !== "undefined") { // Must be first

						this.boxClass_ = opt_opts.boxClass;
						this.setBoxStyle_();
					}
					if (typeof opt_opts.boxStyle !== "undefined") { // Must be second

						this.boxStyle_ = opt_opts.boxStyle;
						this.setBoxStyle_();
					}
					if (typeof opt_opts.content !== "undefined") {

						this.setContent(opt_opts.content);
					}
					if (typeof opt_opts.disableAutoPan !== "undefined") {

						this.disableAutoPan_ = opt_opts.disableAutoPan;
					}
					if (typeof opt_opts.maxWidth !== "undefined") {

						this.maxWidth_ = opt_opts.maxWidth;
					}
					if (typeof opt_opts.pixelOffset !== "undefined") {

						this.pixelOffset_ = opt_opts.pixelOffset;
					}
					if (typeof opt_opts.alignBottom !== "undefined") {

						this.alignBottom_ = opt_opts.alignBottom;
					}
					if (typeof opt_opts.position !== "undefined") {

						this.setPosition(opt_opts.position);
					}
					if (typeof opt_opts.zIndex !== "undefined") {

						this.setZIndex(opt_opts.zIndex);
					}
					if (typeof opt_opts.closeBoxMargin !== "undefined") {

						this.closeBoxMargin_ = opt_opts.closeBoxMargin;
					}
					if (typeof opt_opts.closeBoxURL !== "undefined") {

						this.closeBoxURL_ = opt_opts.closeBoxURL;
					}
					if (typeof opt_opts.infoBoxClearance !== "undefined") {

						this.infoBoxClearance_ = opt_opts.infoBoxClearance;
					}
					if (typeof opt_opts.isHidden !== "undefined") {

						this.isHidden_ = opt_opts.isHidden;
					}
					if (typeof opt_opts.visible !== "undefined") {

						this.isHidden_ = !opt_opts.visible;
					}
					if (typeof opt_opts.enableEventPropagation !== "undefined") {

						this.enableEventPropagation_ = opt_opts.enableEventPropagation;
					}

					if (this.div_) {

						this.draw();
					}
				};

				/**
				 * Sets the content of the InfoBox.
				 *  The content can be plain text or an HTML DOM node.
				 * @param {string|Node} content
				 */
				InfoBox.prototype.setContent = function(content) {
					this.content_ = content;

					if (this.div_) {

						if (this.closeListener_) {

							google.maps.event.removeListener(this.closeListener_);
							this.closeListener_ = null;
						}

						// Odd code required to make things work with MSIE.
						//
						if (!this.fixedWidthSet_) {

							this.div_.style.width = "";
						}

						if (typeof content.nodeType === "undefined") {
							this.div_.innerHTML = this.getCloseBoxImg_() + content;
						} else {
							this.div_.innerHTML = this.getCloseBoxImg_();
							this.div_.appendChild(content);
						}

						// Perverse code required to make things work with MSIE.
						// (Ensures the close box does, in fact, float to the right.)
						//
						if (!this.fixedWidthSet_) {
							this.div_.style.width = this.div_.offsetWidth + "px";
							if (typeof content.nodeType === "undefined") {
								this.div_.innerHTML = this.getCloseBoxImg_() + content;
							} else {
								this.div_.innerHTML = this.getCloseBoxImg_();
								this.div_.appendChild(content);
							}
						}

						this.addClickHandler_();
					}

					/**
					 * This event is fired when the content of the InfoBox changes.
					 * @name InfoBox#content_changed
					 * @event
					 */
					google.maps.event.trigger(this, "content_changed");
				};

				/**
				 * Sets the geographic location of the InfoBox.
				 * @param {LatLng} latlng
				 */
				InfoBox.prototype.setPosition = function(latlng) {

					this.position_ = latlng;

					if (this.div_) {

						this.draw();
					}

					/**
					 * This event is fired when the position of the InfoBox changes.
					 * @name InfoBox#position_changed
					 * @event
					 */
					google.maps.event.trigger(this, "position_changed");
				};

				/**
				 * Sets the zIndex style for the InfoBox.
				 * @param {number} index
				 */
				InfoBox.prototype.setZIndex = function(index) {

					this.zIndex_ = index;

					if (this.div_) {

						this.div_.style.zIndex = index;
					}

					/**
					 * This event is fired when the zIndex of the InfoBox changes.
					 * @name InfoBox#zindex_changed
					 * @event
					 */
					google.maps.event.trigger(this, "zindex_changed");
				};

				/**
				 * Sets the visibility of the InfoBox.
				 * @param {boolean} isVisible
				 */
				InfoBox.prototype.setVisible = function(isVisible) {

					this.isHidden_ = !isVisible;
					if (this.div_) {
						this.div_.style.visibility = (this.isHidden_ ? "hidden" : "visible");
					}
				};

				/**
				 * Returns the content of the InfoBox.
				 * @returns {string}
				 */
				InfoBox.prototype.getContent = function() {

					return this.content_;
				};

				/**
				 * Returns the geographic location of the InfoBox.
				 * @returns {LatLng}
				 */
				InfoBox.prototype.getPosition = function() {
					return this.position_;
				};

				/**
				 * Returns the zIndex for the InfoBox.
				 * @returns {number}
				 */
				InfoBox.prototype.getZIndex = function() {

					return this.zIndex_;
				};

				/**
				 * Returns a flag indicating whether the InfoBox is visible.
				 * @returns {boolean}
				 */
				InfoBox.prototype.getVisible = function() {

					var isVisible;

					if ((typeof this.getMap() === "undefined") || (this.getMap() === null)) {
						isVisible = false;
					} else {
						isVisible = !this.isHidden_;
					}
					return isVisible;
				};

				/**
				 * Shows the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
				 */
				InfoBox.prototype.show = function() {

					this.isHidden_ = false;
					if (this.div_) {
						this.div_.style.visibility = "visible";
					}
				};

				/**
				 * Hides the InfoBox. [Deprecated; use <tt>setVisible</tt> instead.]
				 */
				InfoBox.prototype.hide = function() {

					this.isHidden_ = true;
					if (this.div_) {
						this.div_.style.visibility = "hidden";
					}
				};

				/**
				 * Adds the InfoBox to the specified map or Street View panorama. If <tt>anchor</tt>
				 *  (usually a <tt>google.maps.Marker</tt>) is specified, the position
				 *  of the InfoBox is set to the position of the <tt>anchor</tt>. If the
				 *  anchor is dragged to a new location, the InfoBox moves as well.
				 * @param {Map|StreetViewPanorama} map
				 * @param {MVCObject} [anchor]
				 */
				InfoBox.prototype.open = function(map, anchor) {

					var me = this;

					if (anchor) {
						this.position_ = anchor.getPosition();
						this.moveListener_ = google.maps.event.addListener(anchor, "position_changed", function() {
							me.setPosition(this.getPosition());
						});
					}

					this.setMap(map);

					if (this.div_) {

						this.panBox_();
					}
				};

				/**
				 * Removes the InfoBox from the map.
				 */
				InfoBox.prototype.close = function() {
					var i;
					if (this.closeListener_) {
						google.maps.event.removeListener(this.closeListener_);
						this.closeListener_ = null;
					}
					if (this.eventListeners_) {
						for (i = 0; i < this.eventListeners_.length; i++) {
							google.maps.event.removeListener(this.eventListeners_[i]);
						}
						this.eventListeners_ = null;
					}
					if (this.moveListener_) {
						google.maps.event.removeListener(this.moveListener_);
						this.moveListener_ = null;
					}
					if (this.contextListener_) {
						google.maps.event.removeListener(this.contextListener_);
						this.contextListener_ = null;
					}
					this.setMap(null);
				};

				//return InfoBox;
			}

			// theJ
			// LGEGMC-2455 start
			var selectedMarker = null;
			var resetIcon = null;
			var clickIcon = null;
			// LGEGMC-2455 end
			var firstTime = true; // REQ-048
			var firstLoadAllShop = true;	// LGEEG-399
			var GoogleMaps = {
				options: {
					country: null,
					zoomLevel: 5,
					zoomLevelMin: 2,
					zoomLevelMax: 24,
					viewport: null,
					queryZoomLevel: 10,
					queryUrl: $('#storeSearchForm').attr('action'),
					queryType: "json",
					unitMetric: true,
					useDirection: false,
					centerLatitude: null,
					centerLongitude: null,
					defaultLatitude: $('.find-locally').data('default-latitude'), // REQ-048
					defaultLongitude: $('.find-locally').data('default-longitude'), // REQ-048
					autoSubmit: $('.find-locally').data('default-submit'),
					//defaultZoom: $('.find-locally').data('default-zoomlevel'),
					defaultZoom: 10,
					useController: false,
					useBrand : false,
					debug: false
				},
				_init : function() {
					var self = this;
					self.$localStore = $(".find-locally");
					self.$searchForm = self.$localStore.find('.searchbox form');
					self.$storeSection = self.$localStore.find('.information-on-map');
					self.$toggleBtn = self.$localStore.find('.btn-collapse');
					self.$resultBox = self.$localStore.find('.result-box');
					self.$directionBox = self.$localStore.find('.direction-box');
					self.$storeList = self.$localStore.find("#storeResult .result-list");
					self.$brandList = self.$localStore.find("#brandResult .result-list");
					self.$searchInput = self.$localStore.find('#mapSearch');
					self.$storeSearchForm = self.$localStore.find('#storeSearchForm');
					self.$resultLocation = self.$localStore.find('.search-location'); // select a location 텍스트 영역
					self.$directionsForm = self.$localStore.find('#directionForm');
					self.$storeMapArea = self.$localStore.find('#storeMap');
					self.$countryCombo = self.$localStore.find('#countryList'); // for ae, levant
					self.$stepCity = self.$localStore.find('select[name=stepCity]'); // for eg
					self.$cityCombo = self.$localStore.find('select[name=city]'); // for in
					self.$stateCombo = self.$localStore.find('select[name=state]'); // for in
					self.$routeList = self.$localStore.find("#directionRoute");

					self.locaitonKey = document.getElementById("startInput");
					self.hasSearchInput = self.$localStore.find('.search-results .search-area.type-store').hasClass('active');
					self.hasSearchSubmit = (self.$localStore.find('.searchbox-wrap .select-box button[type=submit]').length>0) ? true:false;

					self.$defaultMsg = self.$resultBox.find(".default-msg");
					self.$noItems = self.$resultBox.find(".no-items");
					self.$btnArea = self.$resultBox.find(".btn-area");

					self.$locationBtn = self.$localStore.find('button.location');

					self.templateList = self.$storeList.find('template.list').clone().html();
					self.templateMap = self.$storeList.find('template.map').clone().html();

					//var $tempCountry = self.$localStore.data("country").split("_")[0] || $("html").data("countrycode").split("_")[0];
			        //self.options.country = $tempCountry.length == 2 ? $tempCountry : self.$countryCombo.find(":selected").val();
					self.options.country = (self.$localStore.data("country")) ? self.$localStore.data("country") : null;
					self.options.useBrand = (self.$resultBox.find('.tabs-type-liner').length>0) ? true : false;
					
					//LGEDZ-36, LGEAF-136 Start
					if($('.GPC0102').find('#brandShopImprovingFlag').val() == 'Y') {
						self.$wtbTab = self.$resultBox.find('.tabs-type-liner');					
					}
					//LGEDZ-36, LGEAF-136 End

					if(!self.options.useBrand) {
						self.$localStore.addClass('no-tab');
					}

					self.geoResult = {};
					self.markers = [];
					self.stores = [];
					self.activeItem;
					self.searchHandle = false;
					self.distance = self.options.distance;
					self.afterControl = false;
					self.openDirection = false; // if true, direction mode

					self.timing = {
						queryTimeout: null
					};
					self.markerIcon = {
						size: new google.maps.Size(30, 43),
						anchor: new google.maps.Point(19, 54)
					}

					// 20200409 START 박지영 : country가 있거나 기본 위치가 있으면 맵 실행
					if(self.options.country != null || (self.options.defaultLatitude && self.options.defaultLongitude)) {
						self.mapSetting();
					}
					// 20200409 END

					$('.GPC0102').on('click', '.get-direction', function(e) {
						e.preventDefault();
						self.openDirection = true;

						// for design
						self.$resultBox.removeClass('active');
						self.$directionBox.addClass('active');
						self.$localStore.find('.search-results .search-area.type-store').removeClass('active')
						self.$localStore.find('.search-results .search-area.type-direction').addClass('active');

						// layer on map
						$(this).closest('.list-box').find('.view-detail-map').trigger('click');

						// address
						var address = $(this).closest('.btns').siblings('.address').text();
						$(this).closest('.find-locally').find('.search-area.type-direction .to div.input').text(address);

						self.setDirection(self.activeItem);
					});
					$('.GPC0102').on('click', '.search-area.type-direction .close a', function(e) {
						e.preventDefault();

						var itemNum = self.activeItem;
						
						// for design
						self.$resultBox.addClass('active');
						self.$directionBox.removeClass('active');
						if(self.hasSearchInput) self.$localStore.find('.search-results .search-area.type-store').addClass('active')
						self.$localStore.find('.search-results .search-area.type-direction').removeClass('active');

						self.directionsDisplay.setMap(null);
						self.directionsDisplay.setPanel(null);

						for (var i = 0; i < self.markers.length; i++) {
							if (!self.markers[i].getVisible()) {
								self.markers[i].setVisible(true);
							}
						}
						self.$resultBox.find('.tabs-cont.active div.list-box[data-item='+itemNum+'] .view-detail-map').trigger('click');;
						self.openDirection = false;

						$('#startInput').val('');
					});

					self.$locationBtn.on('click', function(e) {
						e.preventDefault();
						self.getMyLocation();
					});

					//layer toggle event
					self.$toggleBtn.on('click', function(e) {
						e.preventDefault();
						var list = self.$storeSection;
						// 20200323 START 박지영 : 검색 결과 닫아 놓고 지도 드래그 시 발생하는 오류 수정
						if(!list.hasClass('active')) {
							list.addClass('active');
							self.$localStore.find('.search-results').addClass('active');
						} else {
							list.removeClass('active');
							self.$localStore.find('.search-results').removeClass('active');
						}
						// 20200323 END
					});
					//tab toggle event
					self.$storeSearchForm.on('submit', $.proxy(self.searchAddress, self));
					self.$directionsForm.on('submit', $.proxy(self.setDirectionPanel, self));

					// for ae
					//if(self.options.autoSubmit) {
					//	self.$storeSearchForm.submit();
					//}

					// for ae and levant
					self.$countryCombo.on('change', function(e) {
						self.options.country = ($(this).val() != '') ? $(this).val() : null;
						/*LGEPA-93 add*/
						if(self.options.country=='cb'){
							self.options.country='pa'
						}
						/*//LGEPA-93 add*/
						
						if(self.hasSearchSubmit) return;
						if(!self.options.autoSubmit) {
							self.mapSetting();
						}
						
						if (!self.hasSearchInput) {
							// for ae
							self.$storeSearchForm.submit();
						} else if(COUNTRY_CODE == 'eastafrica'){
							//LGEEASTAF-161
							self.$searchInput.val('');
							self.$storeSearchForm.submit();
						} else {
							// for levent
							// 20200416 START 박지영 - 국가별 위치 맞추기
							//self.$storeSearchForm.submit();
							/*LGEPA-93 add*/
							if(self.options.country=='jo') {
								if ($(window).width()<768) self.map.setZoom(6);
								else self.map.setZoom(7);
							} else if(self.options.country=='iq') {
								if ($(window).width()<768) self.map.setZoom(5);
								else self.map.setZoom(6);
							} else if(self.options.country=='lb') {
								if ($(window).width()<768) self.map.setZoom(7);
								else self.map.setZoom(8);
							} else if(self.options.country=='ps') {
								if ($(window).width()<768) self.map.setZoom(7);
								else self.map.setZoom(8);
							} else if(self.options.country=='sy') {
								if ($(window).width()<768) self.map.setZoom(6);
								else self.map.setZoom(6);
							} else if(self.options.country=='cr') {
								if ($(window).width()<768) self.map.setZoom(6);
								else self.map.setZoom(7);
							}
							/*//LGEPA-93 add*/
							self.$searchInput.val('');
							// 20200416 END
						}
					});
					
					// LGETR-385 Start
					self.$trProvince = self.$localStore.find('select[id=trProvince]');
					self.$trProvince.on('change', function() {
						$(this).closest(".select-box").removeClass("error");
						
						self.trProvince = $(this).val();
						self.$storeSearchForm.find('input[name=stateName]').val(self.trProvince);
						self.$storeSearchForm.find('input[name=cityName]').val("");
						self.keyword.value='';
					});
					
					self.$trCity = self.$localStore.find('select[id=trCity]');
					self.$trProvince.drawAjaxOptions({
		                url: $(this).data('url'),
		                setTarget: document.getElementById("trCity"),
		                dynamicParam: true, // true 이면, select 의 data-param 값을 가져옴
		                callback: function(data) {
		                	self.$trCity.val('all');
		                	self.$trCity.trigger("chosen:updated");
		                	self.$trCity.trigger('change');
		                }
		            });
					
					self.$trCity.on('change', function(e) {
						self.keyword.value='';
						
						self.trCity = $(this).val();
						self.$storeSearchForm.find('input[name=cityName]').val(self.trCity);
					});
					
					self.$category = self.$localStore.find('select[id=category]');
					self.$category.on('change', function() {
						self.category = $(this).val();
						self.$storeSearchForm.find('input[name=categoryId]').val(self.category);
					});
					// LGETR-385 End

					// for eg
					self.$stepCity.on('change', function(e) {
						// 20200409 START 박지영 : eg에서 city 선택시 input 비움
						self.keyword.value='';
						// 20200409 END
						if(self.hasSearchSubmit) return;
						self.$storeSearchForm.submit();
					});

					// for in
					var stateParam = self.$stateCombo.data('param');
					if(stateParam) {
						self.$stateCombo.find('option[value]').each(function() {
							var v = $(this).val();
							$(this).attr('data-param', stateParam+'&state='+v);
						});
					}
					self.$stateCombo.drawAjaxOptions({
						setTarget: document.getElementById('comboCity'),
						dynamicParam: true // true 이면, select 의 data-param 값을 가져옴
					});

					// submit button
					self.$localStore.find('.searchbox form .submit-box button.btn.btn-primary').on('click', function(e) {
						e.preventDefault();
						
						// LGETR-385 Start 
						if(COUNTRY_CODE == "tr"){
							if(self.$storeSearchForm.find('input[name=stateName]').val() == ""){
								self.$trProvince.focus();	
								self.$trProvince.closest('.select-box').addClass("error");
								return;
							}
							
							// 현재 디렉토리 정보가 아닌 검색조건 이용
							self.$storeSearchForm.find('input[name=wtbCateId]').val("");
							if(self.$storeSearchForm.find('input[name=cityName]').val() == "all"){
								self.$storeSearchForm.find('input[name=cityName]').val("");
							}
							
						}
						// LGETR-385 End

						// for design
						self.$resultBox.addClass('active');
						self.$directionBox.removeClass('active');
						self.$localStore.find('.search-results').addClass('active');
						if(self.hasSearchInput) self.$localStore.find('.search-results .search-area.type-store').addClass('active')
						self.$localStore.find('.search-results .search-area.type-direction').removeClass('active');

						// if (self.$countryCombo.length > 0 && self.hasSearchInput) {
						// 20200416 START 박지영 - country 선택하지 않은 경우 지도 반영 안함
						if (self.$countryCombo.length > 0  && self.options.country != null) {
							// for levent and ae
							self.mapSetting();
						}
						// 20200416 END
						self.$storeSearchForm.submit();
					});

					// toggle category 
					self.$storeSection.on('click', '.list-box .category-area .category a', function(e) {
						e.preventDefault();
						e.stopPropagation();
						if(self.$storeList.hasClass('mCustomScrollbar')) self.$storeList.mCustomScrollbar('destroy');
						if(self.$brandList.hasClass('mCustomScrollbar')) self.$brandList.mCustomScrollbar('destroy');
						var $cont = $(this).closest('.category-area');
						var txt;
						if($cont.hasClass('active')) {
							$cont.removeClass('active');
							$(this).attr('aria-expanded', false);
							txt = $(this).data('show-msg');
						} else {
							$cont.addClass('active');
							$(this).attr('aria-expanded', true);
							txt = $(this).data('hide-msg');
						}
						$(this).text(txt);
						
						if($(this).closest('.list').hasClass('slick-initialized')) {
							var sumH = 0;
							for(i=0;i<$(this).closest('.slick-current').find('.list-box').length;i++) {
								sumH = sumH + parseInt($(this).closest('.slick-current').find('.list-box').eq(i).outerHeight());
								console.log(parseInt($(this).closest('.slick-current').find('.list-box').eq(i).outerHeight()), sumH);
							}
							$(this).closest('.slick-list').css('height', sumH);
						}
						return false;
					});
					//LGEDZ-36, LGEAF-136 start
					if($('.GPC0102').find('#brandShopImprovingFlag').val() == 'Y'){
						self.$wtbTab.on('click', 'li a', function(e) {
							
							if(self.$wtbTab.find(".btn-tab.active").attr('href').replace("#",'') === 'brandResult'){
								self.$storeSearchForm.find('input[name=brandshopTabFlag]').val('true');
							}else {
								self.$storeSearchForm.find('input[name=brandshopTabFlag]').val('');
							}
							self.$storeSearchForm.submit();
						})						
					}
					//LGEDZ-36, LGEAF-136 end
				},
				getMyLocation : function() {
					var self = this;
					if ($(this).siblings('input[type=text]').attr('disabled') == 'disabled') {return;}

					self.geocoder = new google.maps.Geocoder;
					function geoError(err) {
						//console.log(error);
						if(err) console.log(err.code, err.message);
						// alert('Geolocation is not supported for this Browser/OS.');
						if($('#geoLocationError').length>0) $('#geoLocationError').modal();
					}
					if (self.options.country == null) {
						// no country
						self.$storeList.removeClass('active');
						self.$brandList.removeClass('active');
						self.$defaultMsg.addClass('active');
						self.$noItems.removeClass('active');
						self.$btnArea.removeClass('active');
						return;
					}
					if (navigator.geolocation) {
						navigator.geolocation.getCurrentPosition(function(position) {
							var latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
							self.geocoder.geocode({
								"location": latLng,
								"region": self.options.country
							}, $.proxy(function(results, status) {
								if (status == google.maps.GeocoderStatus.OK) {
									var geom = results[0].geometry,
										address = results[0].formatted_address,
										viewport = geom.viewport;
									var myform = $(this).closest('form');
									if(!self.openDirection) self.$searchInput.val(address);
									else $(self.locaitonKey).val(address);
									self.map.fitBounds(viewport);
									self.center = self.map.getCenter();
									if(!self.openDirection) self.$storeSearchForm.submit();
									else self.$directionsForm.submit();
								}
							}, self));
						}, geoError, {enableHighAccuracy: true, timeout:1000});
					} else {
						geoError();
					}
				},
				mapSetting : function() {
					var self = this;
					self.mapDiv = document.getElementById("storeMap");
					self.keyword = document.getElementById("mapSearch");
					self.mapOptions = {
						zoom: (firstTime) ? self.options.zoomLevel : self.map.getZoom(),
						mapTypeId: google.maps.MapTypeId.ROADMAP,
						// 20200429 START 박지영 - RTL 옵션 반영
						mapTypeControl: false,
						mapTypeControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.RIGHT_TOP : google.maps.ControlPosition.LEFT_TOP
						},
						panControl: false,
						panControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_TOP : google.maps.ControlPosition.RIGHT_TOP
						},
						zoomControl: true,
						zoomControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_BOTTOM : google.maps.ControlPosition.RIGHT_BOTTOM
						},
						scaleControl: false,
						scaleControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_TOP : google.maps.ControlPosition.RIGHT_TOP
						},
						streetViewControl: true,
						streetViewControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_BOTTOM : google.maps.ControlPosition.RIGHT_BOTTOM
						},
						fullscreenControl: true,
						fullscreenControlOptions: {
							position: ISRTL ? google.maps.ControlPosition.LEFT_TOP : google.maps.ControlPosition.RIGHT_TOP
						},
						// 20200429 END
						minZoom: self.options.zoomLevelMin,
						maxZoom: self.options.zoomLevelMax
					}
					self.infoOptions = {
						disableAutoPan: true,
						alignBottom: true,
						pixelOffset: new google.maps.Size(-162, -54),
						zIndex: 99,
						boxStyle: {
							width: ($(window).width()<768) ? "300px":"360px"
						},
						infoBoxClearance: new google.maps.Size(1, 1),
						enableEventPropagation: true,
						boxClass:  ($(window).width()<768) ? "info-window small" : "info-window"
					};
					self.map = new google.maps.Map(self.mapDiv, self.mapOptions);
					self.infoBox = new InfoBox(self.infoOptions);
					self.directionService = new google.maps.DirectionsService();
					self.directionsDisplay = new google.maps.DirectionsRenderer();
					self.mapControl();
					self.center = self.map.getCenter();
					// 20200409 START 박지영 : 전달 값을 명확하게 변경
					if (firstTime) {
						// REQ-048
						if(!self.options.defaultLatitude || !self.options.defaultLongitude) {
							firstTime = false;
							self.setCountry(self.options.country, 'country');
							if(parseInt(self.options.defaultZoom) > 0) self.map.setZoom(parseInt(self.options.defaultZoom));
							self.autoZipcode(self.keyword);
						} else {
							var pos = new google.maps.LatLng(self.options.defaultLatitude, self.options.defaultLongitude);
							self.setCountry(pos, 'latlng');
							if(parseInt(self.options.defaultZoom) > 0) self.map.setZoom(parseInt(self.options.defaultZoom));
							self.autoZipcode(self.keyword);
						}
					} else {
						self.setCountry(self.options.country, 'country');
						self.autoZipcode(self.keyword);
					}
					// 20200409 END
					
					/* LGESA-304 Start */
					google.maps.event.addListenerOnce(self.map, 'idle', function(){
						if(!!self.$localStore.data('default-locally-keyword') && self.$localStore.data('default-locally-keyword') != 'component-default-locally-keyword' && self.$localStore.data('default-locally-keyword') != ''){
							self.$searchInput.val(self.$localStore.data('default-locally-keyword'));
							setTimeout(function(){
								self.searchAddress();
							}, 1000)
						}
						
						// LGETR-385 Start
						/* LGETR-316 START 
						if($('.GPC0102').find('#modal-pdp-where').length > 0){
							var modal = {
								pdpWhereApproval : {
									modalWindow : $('#modal-pdp-where'),
									modalCancel : $('#modal-pdp-where').find('.pdp-where-cancel-btn'),
									modalConfirm : $('#modal-pdp-where').find('#pdp-where-approval-btn'),
									_init : function(){
										this.modalCancel.off("click").on("click", function(e){
											$('#mapSearch').val('instanbul');
											$('#storeSearchForm').submit();
											$('#mapSearch').val('');
										});
										this.modalConfirm.off("click").on("click", function(e){
											self.getMyLocation();
											//$('.GPC0102').find('.search-area').find('.location').click();
											$('#mapSearch').val('');
										});
									}
								}
							}
							modal.pdpWhereApproval._init();
							let window_url = window.location.href;
							if(window_url.includes('#pdp_where') && window_url.includes('\/tr\/')){
								setTimeout(function(){
									modal.pdpWhereApproval.modalWindow.modal('show');
								}, 1000)
							}
						}
						 */
						/* LGETR-316 END */
						// LGETR-385 End
					});
					/* LGESA-304 End */
				},
				//autocomplet input
				autoZipcode : function(element) {
					// 20200413 START 박지영
					$('.pac-container').remove();
					// 20200413 END
					var self = this;
					// 20200416 START 박지영 : 국가코드 없으면 실행 안함
					if(!self.options.country) return false;
					// 20200416 END
					/*LGEPA-93 add*/
					if(self.options.country=='cb'){
						self.options.country='pa'
					}
					/*//LGEPA-93 add*/
					self.autoCompleteOption = {
						componentRestrictions: {
							country: self.options.country
						}
					};
					//self.autoCompleteOption.componentRestrictions.country = self.options.country;
					self.autoComplete = new google.maps.places.Autocomplete(element, self.autoCompleteOption);
					google.maps.event.addListener(self.autoComplete, 'place_changed', $.proxy(function(e) {
						var place = self.autoComplete.getPlace();
						if (!self.openDirection) {
							setTimeout(function() {
								self.$storeSearchForm.submit();
							}, 100);
						}
					}, self));
				},
				mapControl : function() {
					var self = this;
					//drag event
					google.maps.event.addListener(self.map, 'dragend', $.proxy(function(e) {
						self.center = self.map.getCenter();
						if (!self.openDirection) {
							if (self.afterControl) {
								self.getStore();
								self.setRestrictionByGeocode(self.center)
							}
						}
						google.maps.event.trigger(self.map, "resize");
					}, self));
				},
				queryData : function() {
					var self = this;
					if (self.map.getZoom() < self.options.queryZoomLevel) {
						self.map.setZoom(self.options.queryZoomLevel);
					}
					/*LGEPA-93 add*/
					if(self.results[0].short_name.toLowerCase()=='cr'){
						self.map.setZoom(7);
					}
					/*//LGEPA-93 add*/
					if(DEBUG) console.log('GETZOOM', self.map.getZoom(), self.options.queryZoomLevel);
					
					/* LGEEG-399 start */
					if(firstLoadAllShop && ( COUNTRY_CODE=='eg_en' || COUNTRY_CODE=='eg_ar' )){
						self.map.setZoom(6);	// for full map
					}
					/* LGEEG-399 end */
					//self.reset();
					self.dataque = self.$storeSearchForm.serialize() + "&" + $.param({
						lat: self.map.getCenter().lat(),
						lng: self.map.getCenter().lng(),
						zipCode: self.options.country,
						zoomLevel: (self.map.getZoom()) ? self.map.getZoom() : 10
					});

					if(DEBUG) console.log(self.dataque);

					if(self.$countryCombo.length>0) {
						self.dataque = self.dataque + "&" + $.param({
							country: self.$countryCombo.val()
						});
					}
					if(self.$stepCity.length>0) {
						self.dataque = self.dataque + "&" + $.param({
							stepCity: self.$stepCity.val()
						});
					}
					if(self.$stateCombo.length>0) {
						self.dataque = self.dataque + "&" + $.param({
							state: self.$stateCombo.val()
						});
					}
					if(self.$cityCombo.length>0) {
						self.dataque = self.dataque + "&" + $.param({
							city: self.$cityCombo.val()
						});
					}
					
					/* LGEEG-399 start */
					if(firstLoadAllShop && ( COUNTRY_CODE=='eg_en' || COUNTRY_CODE=='eg_ar' )){
						firstLoadAllShop = false;
						self.dataque = self.dataque + "&" + $.param({
							firstLoadAllShop : "Y"
						});
					}
					/* LGEEG-399 end */
					
					//LGEDZ-36, LGEAF-136 Start
					if($('.GPC0102').find('#brandShopImprovingFlag').val() == 'Y'){
						if(self.options.useBrand) {
							self.dataque = self.dataque + "&" + $.param({
								activeTab: self.$wtbTab.find(".btn-tab.active").attr('href').replace("#",'')
							});
						}						
					}
					//LGEDZ-36, LGEAF-136 end
					//console.log('self.dataque', self.dataque);
					self.center = self.map.getCenter();
					self.clearMarker();
					//console.log(self.map.getCenter().lat(), self.map.getCenter().lng());
					// 20200416 START 박지영 로딩이미지 추가
					$('.GPC0102 .map-container').trigger('ajaxLoadBefore');
					// 20200416 END
					$.ajax({
						type: 'post',
						url: self.options.queryUrl,
						data: xssfilter(self.dataque),
						dataType: self.options.queryType,
						error: function(xhr) {
							//self.reset();
							self.setErrorList();
							//console.log(xhr);
						},
						success: function(d) {
							self.map.process = true;
							self.markers = [];
							self.stores = [];

							if(d) {
								var data = d instanceof Array ? d : d.data;

								if (data.length) {
									var curBounds = new google.maps.LatLngBounds();
									var insetMarker = 0;

									//list reset
									self.$storeList.addClass('active');
									self.$storeList.siblings('.btn-area').removeClass('active');
									self.$storeList.siblings('.default-msg').removeClass('active');
									self.$storeList.siblings('.no-items').removeClass('active');
									self.$brandList.addClass('active');
									self.$brandList.siblings('.btn-area').removeClass('active');
									self.$brandList.siblings('.default-msg').removeClass('active');
									self.$brandList.siblings('.no-items').removeClass('active');

									// 20200525 START 박지영 - 모바일 화면에서 오류 수정
									self.$storeList.find('.list').remove();
									self.$storeList.html('<div class="list"></div>');
									self.$brandList.find('.list').remove();
									self.$brandList.html('<div class="list"></div>');
									// 20200525 END

									self.$brandList.data('brand-count', 0);

									// 20200323 START 박지영 : 검색 결과 닫아 놓고 지도 드래그 시 발생하는 오류 수정
									self.$localStore.find('.search-results').addClass('active');
									// 20200323 END

									if(COUNTRY_CODE == 'gr') var exact = data[0].distance == '0' ? true : false; // LGEGR-295
									$.each(data, function(item) {
										var latlng = new google.maps.LatLng(data[item]['wtbLatitudeValue'], data[item]['wtbLongitudeValue']);
										// 20200416 START 박지영 - 100개 이상일때 아이콘 처리
										if(item>=100) {
											self.markerIcon.url = "/lg5-common-gp/images/customer/mark-00.png";
										} else {
											self.markerIcon.url = "/lg5-common-gp/images/customer/mark-" + (parseInt(item, 10) + 101).toString().substr(1) + ".png";
										}
										// 20200416 END
										var curMarker = $.extend(true, {}, self.markerIcon);
										self.addMarkers(latlng, curMarker, item);
										self.stores.push(data[item]);
										self.setRepairList(data, item);
										setTimeout(function() {
											scrollDesign();
										}, 300);
										curBounds.extend(latlng);
										insetMarker += self.map.getBounds().contains(latlng) ? 1 : 0;
										if(exact) return false; // LGEGR-295
									});

									if(self.$brandList.data('brand-count') == 0) {
										//self.$brandList.parent('div.tabs-cont').removeClass('active').siblings().addClass('active'); //LGETH-397
										self.$brandList.removeClass('active');
										self.$brandList.siblings('.btn-area').removeClass('active');
										self.$brandList.siblings('.default-msg').removeClass('active');
										self.$brandList.siblings('.no-items').addClass('active');
									}
									
									//LGETH-397 Start
									if (!self.$localStore.hasClass('no-tab')) {
										self.$tabs = self.$resultBox.find('.tabs-cont');
										self.$currentTab = self.$tabs.filter('.active');
										if (self.$currentTab.attr('id') !== self.$resultBox.find('.tabs-type-liner a.active').attr('aria-controls')) {
											self.$tabs.not(self.$currentTab.attr('id')).addClass('active');
											self.$currentTab.removeClass('active');
										}
									}
									//LGETH-397 End

									// bind event
									self.$resultBox.find('.list-box .view-detail-map').off('click').on('click', function(e) {
										e.preventDefault();
										e.stopPropagation();

										self.infoBox.close();
										var item = $(this).closest('.list-box').data('item');
										self.activeItem = item;
										if ($(window).width()>=768) {
											//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53
											self.offsetCenter(self.markers[item].getPosition(), 0, -200, self.map);
										} else {
											self.offsetCenter(self.markers[item].getPosition(), 0, -100, self.map);
										}
										// LGEGMC-2455 start
										if( !selectedMarker || selectedMarker !== self.markers[item] ) {
											if(!!selectedMarker) {
												selectedMarker.icon.url = resetIcon;
												resetIcon = "/lg5-common-gp/images/customer/mark-" + (parseInt(item, 10) + 101).toString().substr(1) + ".png";
											} else {
												self.markers[item].setOptions({
													zIndex: 1
												});
												resetIcon = self.markers[item].icon.url;
											}
											clickIcon = "/lg5-common-gp/images/customer/mark-" + (parseInt(item, 10) + 101).toString().substr(1) + "-active.png";
											self.markers[item].icon.url = clickIcon;
											self.markers[item].icon.scaledSize= new google.maps.Size(30, 43);
											if(self.markers[item].icon.url.includes('active')) {
												self.markers[item].setOptions({
													zIndex: 99
												});
											}
										}
										selectedMarker = self.markers[item];
										// LGEGMC-2455 end
										self.setStoreInfo(self.stores, self.infoBox, item);
										self.infoBox.open(self.map, self.markers[item]);

										//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 start
										if($(window).width()<768) {
											if($cont.find('#wtbScrollFlag').val() == 'Y') {
												
												var componentId = $('.GPC0102 .search-results'); 
			                                    self.scrolling(self.getScrollPostion(componentId, 1));
											}	
										}
	                                    //LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 end
										
										self.$resultBox.find('.list-box').not($(this).closest('.list-box')).removeClass('active');
										$(this).closest('.list-box').addClass('active');
									});

									if ($(window).width()<768) {
										self.$storeSection.addClass('active');
									} else {
										setTimeout(function() {
											self.$storeSection.addClass('active');
										}, 200);
									}
									self.$storeSection.addClass('active');
									self.zoom = self.map.getZoom();
									if (self.searchHandle && insetMarker < Math.min(2, data.length)) {
										var minBounds = new google.maps.LatLngBounds();
										for (var k = 0; k < Math.min(2, data.length); k++) {
											var _latlng = new google.maps.LatLng(data[k]['wtbLatitudeValue'], data[k]['wtbLongitudeValue']);
											minBounds.extend(_latlng);
										}
										setTimeout(function() {
											google.maps.event.addListenerOnce(self.map, 'bounds_changed', function(event) {
												if (self.map.getZoom() > 17) {
													self.map.setZoom(17);
												}
											});
											var _latlng = new google.maps.LatLng(self.map.getCenter().lat(), self.map.getCenter().lng());
											minBounds.extend(_latlng);
											self.map.fitBounds(minBounds)
											self.offsetCenter(self.markers[0].getPosition(), 0, 0, self.map);
										}, 350);
									} else if (self.searchHandle && insetMarker >= Math.min(2, data.length)) {
										self.offsetCenter(self.markers[0].getPosition(), 0, 0, self.map);
									}
									if ($(window).width()<768 && data.length>3) {
										// all list for mobile
										self.$storeList.siblings('.btn-area').addClass('active');
										if(self.$storeList.hasClass('mCustomScrollbar')) self.$storeList.mCustomScrollbar('disable', true);
										if(self.$brandList.hasClass('mCustomScrollbar')) self.$brandList.mCustomScrollbar('disable', true);
										setTimeout(function() {
											var $ele = self.$storeList.find('.list');
											$ele.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
												var i = (currentSlide ? currentSlide : 0) + 1;
												self.$storeList.siblings('.btn-area').find(".total-page").text(slick.slideCount);
												self.$storeList.siblings('.btn-area').find(".current-page").text(i);
											});
											$ele.slick({
												adaptiveHeight: true,
												rows: 3,
												slidesPerRow: 1,
												infinite: false,
												dots: false,
												speed: 500,
												// 20200421 START 박지영 - prev, next 버튼 수정
												prevArrow: "#storeResult .pagination .prev",
												nextArrow: "#storeResult .pagination .next"
												// 20200421 END
											});
										}, 500);

										// brand list for mobile
										if(self.$brandList.data('brand-count')>3) {
											self.$brandList.siblings('.btn-area').addClass('active');
											setTimeout(function() {
												var $ele2 = self.$brandList.find('.list');
												$ele2.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
													var i = (currentSlide ? currentSlide : 0) + 1;
													self.$brandList.siblings('.btn-area').find(".total-page").text(slick.slideCount);
													self.$brandList.siblings('.btn-area').find(".current-page").text(i);
												});
												$ele2.slick({
													adaptiveHeight: true,
													rows: 3,
													slidesPerRow: 1,
													infinite: false,
													dots: false,
													speed: 500,
													// 20200421 START 박지영 - prev, next 버튼 수정
													prevArrow: "#brandResult .pagination .prev",
													nextArrow: "#brandResult .pagination .next"
													// 20200421 END
												});
											}, 500);
										}
									}
								} else {
									if(d.businessErrorFlag=="Y" && d.redirectUrl != null) {
										location.href=d.redirectUrl;
									} else {
										//self.reset();
										self.setErrorList();
									}
								}

							} else {
								if(d.businessErrorFlag=="Y" && d.redirectUrl != null) {
									location.href=d.redirectUrl;
								} else {
									//self.reset();
									self.setErrorList();
								}
							}
							self.map.process = false;
						},
						complete: function() {
							self.searchHandle = false;
							// 20200416 START 박지영 로딩이미지 추가
							$('.GPC0102 .map-container').trigger('ajaxLoadEnd');
							// 20200416 END
						}
					})
				},
				getStore : function(force) {
					var self = this;
					clearTimeout(self.timing.queryTimeout);
					//console.log(!self.infoBox.getVisible());
					if (!self.infoBox.getVisible() || force) {
						self.reset();
						self.timing.queryTimeout = setTimeout($.proxy(self.queryData, self), 200);
					}
				},
				// 20200409 START 박지영 : 전달 값을 명확하게 변경
				setCountry : function(address, dir) {
					var self = this;
					self.geocoder = new google.maps.Geocoder;
					var slocation = {};
					if(self.openDirection || dir=='latlng') {
						slocation = {"location": address}
					} else if(dir=='country') {
						slocation = {"componentRestrictions": {"country":address}}
 					} else {
						slocation = {"address": address}
					}
					self.geocoder.geocode(slocation, $.proxy(function(results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							self.geoResult.locations = results[0].geometry.location;
							// 20200416 START 박지영 offsetCenter 수정
							/*
							if (self.openDirection || firstTime) { // REQ-048
								self.offsetCenter(self.geoResult.locations, 0, 0, self.map);
								firstTime=false; // REQ-048
							} else {
								self.offsetCenter(self.geoResult.locations, 0, 0, self.map);
							}
							*/
							self.offsetCenter(self.geoResult.locations, 0, 0, self.map);
							firstTime=false; // REQ-048
							//if ($(window).width()<768) self.offsetCenter(self.geoResult.locations, 100, -80, self.map);
							// 20200416 END
						}
					}, this));
				},
				// 20200409 END
				addMarkers : function(latlng, marker, itemNum) {
					var self = this;
					var bounds = new google.maps.LatLngBounds();
					var currMarker = self;

					var marker = new google.maps.Marker({
						map: self.map,
						icon: marker,
						draggable: false,
						position: latlng,
						zIndex: 1
					});

					marker.setVisible(true);
					self.markers.push(marker);

					google.maps.event.addListener(marker, "click", function(e) {
						// LGEGMC-2455 start
						if( !selectedMarker || selectedMarker !== marker ) {
							if(!!selectedMarker) {
								selectedMarker.icon.url = resetIcon;
								resetIcon = "/lg5-common-gp/images/customer/mark-" + (parseInt(itemNum, 10) + 101).toString().substr(1) + ".png";
							} else {
								resetIcon = marker.icon.url;
							}
							clickIcon = "/lg5-common-gp/images/customer/mark-" + (parseInt(itemNum, 10) + 101).toString().substr(1) + "-active.png";
							marker.icon.url = clickIcon;
							marker.icon.scaledSize= new google.maps.Size(30, 43);
						}
						selectedMarker = marker;
						// LGEGMC-2455 end
						self.infoBox.open(self.map, this);
						self.onItem(itemNum);
						self.focusList(itemNum);
						// LGEGMC-2455
						this.setOptions({
							zIndex: 99
						});
					});

					google.maps.event.addListener(marker, 'mouseover', function() {
						this.setOptions({
							zIndex: 9
						});
					})
				},
				offsetCenter : function(latlng, offsetx, offsety, map) {
					var self = this;
					var scale = Math.pow(2, map.getZoom());
					var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
					var pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);
					var worldCoordinateNewCenter = new google.maps.Point(worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);
					var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
					map.panTo(newCenter);
				},
				//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 start
				getScrollPostion : function(tg){
					var offsetTop = Math.round(tg.offset().top);

					tg.hasClass("iw_placeholder") || 
					tg.find(".iw_placeholder").length > 0 || 
					tg.closest(".iw_placeholder").length > 0 

					return offsetTop;
				},
				scrolling : function (pos){
					$('html, body').animate({
						scrollTop: pos
					//}, "fast");
					},{duration:500});// LGEITF-428
				},
				//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 end
				setStoreInfo : function(data, self, itemNum) {
					var data = data[itemNum];

					//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 start
					var categoryString = "";
					if(!!data["superCategory"]) {
						if($cont.find('#wtbTitleFlag').val() == 'Y'){
		                    var strSuper = data["superCategory"].split(",");								
		                    const set = Array.from(new Set(strSuper));

		                    for(var c1 = 0; c1 < set.length; c1++) {
		                    	var supCategory = '<span class="bold">' + "ㆍ" + set[c1] + '</span>';

		                        var products = " : " + data["categoryCode"][set[c1]] + "<br>";
		                        products = products.replace(/,/g, ", "); // LGEIN-702
		                        categoryString += supCategory.concat(products);
		                    }
						}
						else {
							categoryString = data["productCode"].join(', ');
						}
					}
					//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 end
					
					data["marker"] = this.getChangeMarker(itemNum); // LGEGMC-2455
					
					var content = this.templateMap
								.replace(/\*itemNum\*/g, itemNum)
								.replace(/\*distance\*/g, data["distance"])
								.replace(/\*marker\*/g, data["marker"]) // LGEGMC-2455 
								.replace(/\*logo\*/g, (!data["logo"]) ? '/lg5-common-gp/images/common/product-default-list-165.jpg' : data["logo"])
								.replace(/\*wtbName\*/g, data["wtbName"])
								.replace(/\*address\*/g, data["address"])
								// 20200416 START 박지영 주소 데이터 수정 
								.replace(/\*addressLine1Info\*/g, data["addressLine1Info"] || data["address"])
								// 20200416 END
								.replace(/\*pinCode\*/g, data["pinCode"])
								.replace(/\*stdCode\*/g, data["stdCode"])
								.replace(/\*wtbPhoneNo\*/g, data["wtbPhoneNo"])
								.replace(/\*wtbFaxNo\*/g, data["wtbFaxNo"])
								.replace(/\*wtbEmail\*/g, data["wtbEmail"])
								.replace(/\*wtbTime\*/g, data["wtbTime"])
								.replace(/\*wtbUrl\*/g, data["wtbUrl"])
								.replace(/\*productCode\*/g, categoryString) //LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53
								;

					var $template = $(content),
						$keyBlocks = $template.find('*[data-key]');

					for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
						var $currentKeyBlock = $keyBlocks.eq(i1),
							key = $currentKeyBlock.get(0).getAttribute('data-key'),
							val = data[key];
						if(!val || val==null) {
							$currentKeyBlock.remove();
						}
					}

					var template = $template.get(0).outerHTML;
					self.setContent(template);
					//LGEGMC-2455 start
					setTimeout(function() {
						if($(window).width()<768) {
							if($(".info-window .info-window-wrap").hasClass('mCustomScrollbar')) $(".info-window .info-window-wrap").mCustomScrollbar('disable', true);
						} else {
							$(".info-window .info-window-wrap").mCustomScrollbar({
								theme:'dark',
							});
							if (($(".info-window .info-window-wrap .mCustomScrollBox").attr('style')).includes('none')) $(".info-window .info-window-wrap").mCustomScrollbar('disable', true);
						}
					}, 100);
					//LGEGMC-2455 end
				},
				// LGEGMC-2455 start
				getChangeMarker : function(itemNum) {
					if(itemNum>=100) {
						return "/lg5-common-gp/images/customer/mark-00-active.png";
					} else {
						return "/lg5-common-gp/images/customer/mark-" + (parseInt(itemNum, 10) + 101).toString().substr(1) + "-active.png";
					}
				},
				// LGEGMC-2455 end
				searchAddress : function(e) {
					var self = this,
						address = self.$searchInput.val(),
						$searchEle = self.$searchForm.find("select, input"),
						geocoderOptions;

					self.geocoder = new google.maps.Geocoder;
					/* LGESA-304 Start */
					if(!!e) e.preventDefault();
					/* LGESA-304 End */
					
					if (self.options.country == null) {
						// no country
						self.$storeList.removeClass('active');
						self.$brandList.removeClass('active');
						self.$defaultMsg.addClass('active');
						self.$noItems.removeClass('active');
						self.$btnArea.removeClass('active');
						return;
					} else {
						if(self.$countryCombo.length>0 || self.$stepCity.length > 0) {	/* LGEEG-399 add stepCity condition */
							// 20200520 START 박지영 - country와 input이 둘다 존재하는 경우 수정
							if(self.hasSearchInput){
								if(self.$searchInput.val()==""||self.$searchInput.val()==null){
									geocoderOptions = {
										"address":self.options.country,
										componentRestrictions: {
											"country": self.options.country
										}
									};
								} else {
									geocoderOptions = {
										"address": self.$searchInput.val(),
										"region": self.options.country
									};
								}
							} else {
								geocoderOptions = {
									"address":self.options.country,
									componentRestrictions: {
										"country": self.options.country
									}
								};
							}
							if(self.$stepCity.length > 0){
								if(self.$searchInput.val()==""||self.$searchInput.val()==null){
									if(self.$stepCity.val()=="Others"){
										//self.$searchInput.parents("li[class*=step]").addClass("open-tooltip")
										//return;
									}
									/* LGEEG-399 start */
									if(firstTime && ( COUNTRY_CODE=='eg_en' || COUNTRY_CODE=='eg_ar' )){
										geocoderOptions = {
												"address": self.$stepCity[0].options[1].value,
												"region": self.options.country
											};
									} else {
									/* LGEEG-399 end */
										geocoderOptions = {
												"address": self.$stepCity.val(),
												"region": self.options.country
										};
									}	// LGEEG-399 add
								} else {
									//self.$stepCity.find("option:last-child").prop("selected", true).trigger("chosen:updated");	// LGEEG-399 add
									geocoderOptions = {
										"address": self.$searchInput.val(),
										"region": self.options.country
									};
								}
							}
							// 20200520 END
						} else if(self.$searchInput.length>0 && self.$searchInput.is(':visible')) {
							if(self.$stepCity.length > 0){
								if(self.$searchInput.val()==""||self.$searchInput.val()==null){
									if(self.$stepCity.val()=="Others"){
										//self.$searchInput.parents("li[class*=step]").addClass("open-tooltip")
										//return;
									}
									
									geocoderOptions = {
											"address": self.$stepCity.val(),
											"region": self.options.country
									};
								} else {
									//self.$stepCity.find("option:last-child").prop("selected", true).trigger("chosen:updated");	// LGEEG-399 add
									geocoderOptions = {
										// 20200416 START 박지영 - EG에서 city 선택하지 않고 검색어 입력하는 경우 
										"address": self.$searchInput.val()//,
										//"region": self.options.country
										// 20200416 END
									};
								}
							} else {
								geocoderOptions = {
									"address": self.$searchInput.val()
								};
							}
						// LGETR-385 Start
						} else if(self.$trProvince.length>0) {
							geocoderOptions = {
								"address":self.$storeSearchForm.find('input[name=stateName]').val()
							};

						// LGETR-385 End
						}else {
							// in case
							if(self.$cityCombo.length > 0 && self.$stateCombo.length>0) {
								geocoderOptions = {
									"address": self.$cityCombo.val() + ' ' + self.$stateCombo.val()
								};
							} else if(self.$cityCombo.length > 0) {
								geocoderOptions = {
									"address": self.$cityCombo.val()
								};
							} else if(self.$stateCombo.length > 0) {
								geocoderOptions = {
									"address": self.$stateCombo.val()
								};
							} else {
								geocoderOptions = {
									"address": self.options.country
								};
							}
							/*
							4.0 code
							var lastIndex = self.$searchForm.find(".select").length - 1;
							self.$searchForm.find(".select").each(function(index){
								var val = $(this).val();

								if(val != 'all' && val != $(this).data("placeholder")){
									if(index != lastIndex){
										address += $(this).val() + " ";
									}else{
										address += $(this).val();
									}
								}
							});
							geocoderOptions = {
								"address": address
							};
							*/

						}
					}
					
					//console.log(geocoderOptions);
					if(address == 'null' || address == null) return;
						//console.log('test3');

					if(DEBUG) console.log(geocoderOptions);
					self.geocoder.geocode(geocoderOptions, function(results, status) {
						if (status == google.maps.GeocoderStatus.OK) {

							//console.log('submit');
							var geom = results[0].geometry,
								location = geom.location,
								address = results[0].formatted_address,
								viewport = geom.viewport;
							self.center = self.map.getCenter();
							self.results = results[0].address_components;
							self.zipcode;
							for (var i = self.results.length - 1; i > -1; i--) {
								self.address = self.results[i];
								if (self.address.types[0] == "postal_code") {
									self.zipcode = self.address.long_name;
									break;
								}
							}

							var markerOptions = {
								position: location,
								title: address,
								animation: google.maps.Animation.DROP
							};
							self.$resultLocation.text(address);
							self.map.fitBounds(viewport);
							self.afterSearch();
							self.afterControl = true;
							
							//var product = ($('#repairProduct').find('option:selected').text());
							//product = changeTitleFormat(product);
							//address = changeTitleFormat(address);
							//adobeTrackEvent('cs-find-service-center-submit', {service_center_location : address, service_center_search_product : product, page_event : {service_center_search : true}});

						} else {
							self.reset();
							self.setErrorList();
							self.afterControl = false;
						}
					});

					var slist = $(".store-list", self.$storeSearchForm);
					if($('.navigation').length>0 && !$('.navigation').is('.mobile-device')) {
						setTimeout(function() {
							if($(window).width()<768) {
								if(slist.hasClass('mCustomScrollbar')) slist.mCustomScrollbar('disable', true);
							} else {
								//if(slist.hasClass('mCustomScrollbar')) slist.mCustomScrollbar('disable', false);
								if(slist.hasClass('mCustomScrollbar')) slist.mCustomScrollbar('update');
							}
						}, 500);
					}
				},
				afterSearch : function() {

					var self = this;
					self.reset();
					self.searchHandle = true;
					self.distance = 25;
					self.getStore();
				},
				// 20200326 START 이지원 slick pagination focus 수정
				focusList : function(item, callback) {
					// console.log(item);
					if($('.navigation').length>0){
						var tabActive = $('.tabs-cont.active'),
							resultList = tabActive.find('.result-list'),
							slist = resultList.find('.list'),
							currentPage = Math.floor(item / 3),
							dontAnimate = true;

						if(!$('.navigation').is('.mobile-device')){
							var currentItem = slist.find('.list-box[data-item="'+item+'"]');
							resultList.mCustomScrollbar('scrollTo', currentItem);
						} else {
							if (item >= 0 && item < 3) {
								slist.slick('slickGoTo', 0, dontAnimate)
							} else {
								slist.slick('slickGoTo', currentPage, dontAnimate);
							}
						}
					}
				},
				// 20200326 END
				onItem : function(item) {
					//console.log('onItem', item, typeof(item));
					var self = this;
					$("div.list-box", "#storeResult").removeClass("active").filter("div.list-box[data-item='" + item + "']").addClass("active");
					$("div.list-box", "#brandResult").removeClass("active").filter("div.list-box[data-item='" + item + "']").addClass("active");

					if (typeof(self.infoBox) != "undefined") {
						if (typeof(item) == "undefined" || item == "undefined") {
							self.infoBox.close();
							self.activeItem = null;
						} else if (self.activeItem != item) {
							self.infoBox.close();
							self.activeItem = item;
							if ($(window).width()>=768) {
								//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53
								self.offsetCenter(self.markers[item].getPosition(), 0, -200, self.map);
							} else {
								self.offsetCenter(self.markers[item].getPosition(), 0, -100, self.map);
							}
							self.setStoreInfo(self.stores, self.infoBox, item);
							self.infoBox.open(self.map, self.markers[item]);
						} else if (self.activeItem == item && !self.infoBox.getVisible()) {
							self.infoBox.Content(null);
							self.offsetCenter(self.markers[item].getPosition(), 0, -100, self.map);
							self.setStoreInfo(self.stores, self.infoBox, item);
							self.infoBox.open(self.map, self.markers[item]);
						}
					}
				},
				setDirection : function(item) {
					var self = this;
					var startInput = document.getElementById("startInput");
					self.$routeList.html(null);

					if (self.openDirection) {

						var data = self.stores[item];
						for (var i = 0; i < self.markers.length; i++) {
							if (self.markers[i].getVisible()) {
								self.markers[i].setVisible(false);
							}
						}
						self.markers[item].setVisible(true);
						self.directionAutocomplete = new google.maps.places.Autocomplete(startInput, self.autoCompleteOption);
						google.maps.event.addListener(self.directionAutocomplete, 'place_changed', $.proxy(function(e) {
							self.$directionsForm.submit();
						}, self));

						self.$routeList.removeClass('active');
						self.$routeList.siblings('.direction-title').removeClass('active');
						self.$routeList.siblings('.default-msg').addClass('active');
						self.$routeList.siblings('.no-items').removeClass('active');

					}
				},
				setDirectionPanel : function(e) {

					e.preventDefault();
					var self = this;

					var routeList = document.getElementById("directionRoute");
					var unit = self.options.unitMetric ? google.maps.UnitSystem.METRIC : google.maps.UnitSystem.IMPERIAL;
					var origin = self.directionAutocomplete.getPlace();
					var destination = self.markers[self.activeItem].getPosition();

					if(typeof(origin) == "undefined"){
						return;
					}

					if (!origin.geometry) {
						self.$routeList.removeClass('active');
						self.$routeList.siblings('.direction-title').removeClass('active');
						self.$routeList.siblings('.default-msg').removeClass('active');
						self.$routeList.siblings('.no-items').addClass('active');
						return;
					}
					self.$routeList.addClass('active');
					self.$routeList.siblings('.direction-title').addClass('active');
					self.$routeList.siblings('.default-msg').removeClass('active');
					self.$routeList.siblings('.no-items').removeClass('active');

					var directionRoute = {
						origin: origin.geometry.location,
						destination: destination,
						travelMode: google.maps.TravelMode.DRIVING,
						unitSystem: unit
					};
					if (self.directionsDisplay) {
						self.directionsDisplay.setMap(self.map);
						self.directionsDisplay.setPanel(routeList);
					}

					self.directionService.route(directionRoute, function(response, status) {
						if (status == google.maps.DirectionsStatus.OK) {
							self.directionsDisplay.setDirections(response);
							for (var i = 0; i < self.markers.length; i++) {
								if (self.markers[i].getVisible())
									self.markers[i].setVisible(false);
							}
							self.infoBox.close();
						} else {
							self.directionsDisplay.setMap(null);
							self.directionsDisplay.setPanel(null);
						}
					});
				},
				//query string ascPostalCode make
				setRestrictionByGeocode : function(loc) {
					var self = this;
					self.geocoder.geocode({
						'location': loc
					}, function(results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							self.results = results[0].address_components;
							for (var i = self.results.length - 1; i > -1; i--) {
								self.address = self.results[i];
								if (self.address.types[0] == "postal_code") {
									self.zipcode = self.address.long_name;
									break;
								}
							}

						}
					});
				},
				clearMarker : function(map) {
					var self = this;
					for (var i = 0; i < self.markers.length; i++) {
						self.markers[i].setMap(null);
					}
					self.markers = [];
				},
				setRepairList : function(data, itemNum) {
					var self = this;
					var data = data[itemNum];

					//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 start
					var categoryString = "";
					if(!!data["superCategory"]) {
						if($cont.find('#wtbTitleFlag').val() == 'Y'){
		                    var strSuper = data["superCategory"].split(",");								
		                    const set = Array.from(new Set(strSuper));

		                    for(var c1 = 0; c1 < set.length; c1++) {
		                    	var supCategory = '<span class="bold">' + "ㆍ" + set[c1] + '</span>';

		                        var products = " : " + data["categoryCode"][set[c1]] + "<br>";
		                        products = products.replace(/,/g, ", "); // LGEIN-702
		                        categoryString += supCategory.concat(products);
		                    }
						}
						else {
							categoryString = data["productCode"].join(', ');
						}
					}
					//LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53 end
					//console.log('!!', itemNum);
					
					var content = self.templateList
								.replace(/\*itemNum\*/g, itemNum)
								.replace(/\*itemNum2\*/g, (parseInt(itemNum)+1))
								.replace(/\*distance\*/g, data["distance"])
								.replace(/\*logo\*/g, (!data["logo"]) ? '/lg5-common-gp/images/common/product-default-list-165.jpg' : data["logo"])
								.replace(/\*wtbName\*/g, data["wtbName"])
								.replace(/\*address\*/g, data["address"])
								// 20200416 START 박지영 주소 데이터 수정
								.replace(/\*addressLine1Info\*/g, data["addressLine1Info"] || data["address"])
								// 20200416 END
								.replace(/\*pinCode\*/g, data["pinCode"])
								.replace(/\*stdCode\*/g, data["stdCode"])
								.replace(/\*wtbPhoneNo\*/g, data["wtbPhoneNo"])
								.replace(/\*wtbFaxNo\*/g, data["wtbFaxNo"])
								.replace(/\*wtbEmail\*/g, data["wtbEmail"])
								.replace(/\*wtbTime\*/g, data["wtbTime"])
								.replace(/\*wtbUrl\*/g, data["wtbUrl"])
								.replace(/\*productCode\*/g, categoryString) //LGEAE-366, LGELK-7, LGEEASTAF-92, LGEVN-405, LGESA-263, LGEID-154, LGENP-6, LGEDZ-53
								;

					var $template = $(content),
						$keyBlocks = $template.find('*[data-key]');
					/* LGEJO-128 start*/
					var viewOnlineMsgShopId = $("#viewOnlineMsgShopId").val();
					if(viewOnlineMsgShopId.indexOf(data["wtbId"])!=-1){
						$template.find('a.view-online').text($("#viewOnlineMsg").val())
					}
					/* LGEJO-128 end*/	
					for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
						var $currentKeyBlock = $keyBlocks.eq(i1),
							key = $currentKeyBlock.get(0).getAttribute('data-key'),
							val = data[key];
						if(!val || val==null) {
							$currentKeyBlock.remove();
						}
					}

					var template = $template.get(0).outerHTML;
					self.$storeList.find('.list').append(template);

					// 20200319 START 박지영 - unslick 이 제대로 되지 않았던 버그 수정
					if(self.$storeList.find('.list').hasClass('slick-initialized')) {
						self.$storeList.find('.list').slick('unslick');
					}
					// 20200319 END

					if(self.options.useBrand && data["brand"]=="true") {
						self.$brandList.data('brand-count', parseInt(self.$brandList.data('brand-count'))+1);
						self.$brandList.find('.list').append(template);
						// 20200319 START 박지영 - unslick 이 제대로 되지 않았던 버그 수정
						if(self.$brandList.find('.list').hasClass('slick-initialized')) {
							self.$brandList.find('.list').slick('unslick');
						}
						// 20200319 END
					}
				},
				setErrorList : function() {
					var self = this;
					//if (self.$searchInput.val() != "") {
						//console.log(self.$defaultMsg.length);
						self.$storeList.removeClass('active');
						self.$brandList.removeClass('active');
						self.$defaultMsg.removeClass('active');
						self.$btnArea.removeClass('active');
						self.$noItems.addClass('active');
					//}
				},
				reset : function() {
					var self = this;
					self.clearMarker();
					self.onItem();
					self.activeItem = null;

					if (typeof(self.infoBox) != "undefined") self.infoBox.close();
					self.infoBox.setContent(null);
					self.directionsDisplay.setMap(null);
					self.directionsDisplay.setPanel(null);
					self.$storeList.mCustomScrollbar("destroy");
					self.$brandList.mCustomScrollbar("destroy");
					self.$storeList.find('.list').html('');
					self.$brandList.find('.list').html('');
					self.$storeSection.addClass("active");
					self.$noItems.removeClass('active');
					self.$btnArea.removeClass('active');

					if(self.$storeList.hasClass('slick-slider') || self.$storeList.hasClass('slick-initialized')) {
						self.$storeList.slick('unslick');
						self.$storeList.removeClass('slick-slider').removeClass('slick-initialized');
					}
				},
				resizing : function() {
					var self = this;
					self.center = self.map.getCenter();
					google.maps.event.trigger(self.map, "resize");
					self.map.setCenter(self.center);
				}
			};

			GoogleMaps._init();
			
			// EASTAF-171 START
			if(COUNTRY_CODE == 'eastafrica'){
				
				var dataCountry = $('.find-locally').data('country').toLowerCase();
				var countryListYn = "N";
				
				$("#countryList").find("option").each(function(i) {
					if($(this).val() != "" && dataCountry == $(this).val()){
						countryListYn = "Y";
						return false;
					}
				});
				
				if(countryListYn == "N"){
					dataCountry = "ke";
				}
				
				$("#countryList").val(dataCountry).trigger('chosen:updated');
				$("#countryList").val(dataCountry).trigger('change');
			}
			// EASTAF-171 END
			/* LGEEG-399 start */
			if(COUNTRY_CODE=='eg_en' || COUNTRY_CODE=='eg_ar'){
				$('#storeSearchForm').submit();
			}
			/* LGEEG-399 end */
			
		};

		//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
			var mapFlag = false;
			$(window).scroll(function() {
				var t= $('.GPC0102 .find-locally').eq(0).offset().top;
				var b= t + $('.GPC0102 .find-locally').eq(0).height();
				if(isInScreen(t, b)) {
					if(!mapFlag) {
						mapFlag = true;

						var script = document.createElement('script');
						//var region = $('.find-locally').data('country') ? $('.find-locally').data('country').toUpperCase() : 'KR';
						//script.src = '//maps.googleapis.com/maps/api/js?v=3.39&libraries=places&client=gme%2Dlgelectronicsinc1&callback=initialize&region='+region+'&language=' + document.documentElement.lang;
						// 20200427 START 박지영 - tw 국가 중국어 번체로 변경
						var lang = document.documentElement.lang;
						if(COUNTRY_CODE.toLowerCase() == 'tw') lang = "zh-TW";
						//LGCOMMA-39 Start
						var region = "KR";
						if(COUNTRY_CODE.toLowerCase() == 'ma') region = "MA";
						script.src = '//maps.googleapis.com/maps/api/js?v=3.39&libraries=places&client=gme%2Dlgelectronicsinc1&callback=initialize&region=' + region + '&language=' + lang;
						//LGCOMMA-39 End
						// 20200427 END
						document.body.appendChild(script);
					}
				}
			}).scroll();
		//}
	}

	// find-locally-cn
	if($cont.find('.find-locally-cn').length > 0) {
		
		/* LGECN-214 Start */
		if(typeof _hmt != 'undefined'){
			$cont.find('.find-locally-cn').find('.searchbox form .submit-box button.btn.btn-primary').on('click', function(e) {
				var searchbox = $(this).parents('.searchbox');
			    var search_state_province = searchbox.find('[name="region"] option:checked').text();
			    var search_city = searchbox.find('[name="city"] option:checked').text();
			    var product_name = searchbox.find('[name="superCategory"] option:checked').text();
			    var product_category = searchbox.find('[name="category"] option:checked').text();
			    
			    console.log('[Baidu trackEvent] [where_to_buy_submit] ', ', search_state_province : '+ search_state_province, ', search_city : '+search_city, ', product_name : '+product_name, ', product_category : '+product_category);
			    
			    _hmt.push(['_trackCustomEvent', 'where_to_buy_submit', {
			        'search_state_province': search_state_province,
			        'search_city': search_city,
			        'product_name': product_name,
			        'product_category': product_category
			    }]);
			});
		}
		/* LGECN-214 End */
		
		// eprivacy
		// 중국 지도에서 생성하는 쿠키 BAIDUID / CS_JSESSIONID / WMONID
		$cont.find('.find-locally-cn').each(function() {
			var obj = $(this).find('.map-container');
			if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
				obj.closest('.find-locally-cn').addClass('active');
			} else {
				obj.parent().find('.searchbox-wrap').remove();
				obj.parent().find('.search-results').remove();
				ePrivacyCookies.view('load', '', obj);
				obj.css('background', '#fff');
				obj.closest('.find-locally-cn').addClass('active');
				return false;
			}
		});

		// baidu map
		var loadScript = function() {

			// infoBox
				var BMapLib = window.BMapLib = BMapLib || {};
				//常量，infoBox可以出现的位置，此版本只可实现上下两个方向。
				var INFOBOX_AT_TOP = 1,
					INFOBOX_AT_RIGHT = 2,
					INFOBOX_AT_BOTTOM = 3,
					INFOBOX_AT_LEFT = 4;
				(function() {
					//声明baidu包
					var T, baidu = T = baidu || {
						version: '1.5.0'
					};
					baidu.guid = '$BAIDU$';
					//以下方法为百度Tangram框架中的方法，请到http://tangram.baidu.com 查看文档
					(function() {
						window[baidu.guid] = window[baidu.guid] || {};

						baidu.lang = baidu.lang || {};
						baidu.lang.isString = function(source) {
							return '[object String]' == Object.prototype.toString.call(source);
						};
						baidu.lang.isFunction = function(source) {
							return '[object Function]' == Object.prototype.toString.call(source);
						};
						baidu.lang.Event = function(type, target) {
							this.type = type;
							this.returnValue = true;
							this.target = target || null;
							this.currentTarget = null;
						};


						baidu.object = baidu.object || {};
						baidu.extend =
							baidu.object.extend = function(target, source) {
								for (var p in source) {
									if (source.hasOwnProperty(p)) {
										target[p] = source[p];
									}
								}

								return target;
							};
						baidu.event = baidu.event || {};
						baidu.event._listeners = baidu.event._listeners || [];
						baidu.dom = baidu.dom || {};

						baidu.dom._g = function(id) {
							if (baidu.lang.isString(id)) {
								return document.getElementById(id);
							}
							return id;
						};
						baidu._g = baidu.dom._g;
						baidu.event.on = function(element, type, listener) {
							/*
							type = type.replace(/^on/i, '');
							element = baidu.dom._g(element);
							var realListener = function(ev) {
									// 1. 这里不支持EventArgument,  原因是跨frame的事件挂载
									// 2. element是为了修正this
									listener.call(element, ev);
								},
								lis = baidu.event._listeners,
								filter = baidu.event._eventFilter,
								afterFilter,
								realType = type;
							type = type.toLowerCase();
							// filter过滤
							if (filter && filter[type]) {
								afterFilter = filter[type](element, type, realListener);
								realType = afterFilter.type;
								realListener = afterFilter.listener;
							}

							// 事件监听器挂载
							if (element.addEventListener) {
								element.addEventListener(realType, realListener, false);
							} else if (element.attachEvent) {
								element.attachEvent('on' + realType, realListener);
							}
							// 将监听器存储到数组中
							lis[lis.length] = [element, type, listener, realListener, realType];
							*/
							return element;
						};

						//baidu.on = baidu.event.on;
						baidu.event.un = function(element, type, listener) {
							element = baidu.dom._g(element);
							type = type.replace(/^on/i, '').toLowerCase();

							var lis = baidu.event._listeners,
								len = lis.length,
								isRemoveAll = !listener,
								item,
								realType, realListener;
							while (len--) {
								item = lis[len];

								if (item[1] === type && item[0] === element && (isRemoveAll || item[2] === listener)) {
									realType = item[4];
									realListener = item[3];
									if (element.removeEventListener) {
										element.removeEventListener(realType, realListener, false);
									} else if (element.detachEvent) {
										element.detachEvent('on' + realType, realListener);
									}
									lis.splice(len, 1);
								}
							}

							return element;
						};
						baidu.un = baidu.event.un;
						baidu.dom.g = function(id) {
							if ('string' == typeof id || id instanceof String) {
								return document.getElementById(id);
							} else if (id && id.nodeName && (id.nodeType == 1 || id.nodeType == 9)) {
								return id;
							}
							return null;
						};
						baidu.g = baidu.G = baidu.dom.g;
						baidu.dom._styleFixer = baidu.dom._styleFixer || {};
						baidu.dom._styleFilter = baidu.dom._styleFilter || [];
						baidu.dom._styleFilter.filter = function(key, value, method) {
							for (var i = 0, filters = baidu.dom._styleFilter, filter; filter = filters[i]; i++) {
								if (filter = filter[method]) {
									value = filter(key, value);
								}
							}
							return value;
						};
						baidu.string = baidu.string || {};

						baidu.string.toCamelCase = function(source) {
							//提前判断，提高getStyle等的效率 thanks xianwei
							if (source.indexOf('-') < 0 && source.indexOf('_') < 0) {
								return source;
							}
							return source.replace(/[-_][^-_]/g, function(match) {
								return match.charAt(1).toUpperCase();
							});
						};

						baidu.dom.setStyle = function(element, key, value) {
							var dom = baidu.dom,
								fixer;

							// 放弃了对firefox 0.9的opacity的支持
							element = dom.g(element);
							key = baidu.string.toCamelCase(key);

							if (fixer = dom._styleFilter) {
								value = fixer.filter(key, value, 'set');
							}

							fixer = dom._styleFixer[key];
							(fixer && fixer.set) ? fixer.set(element, value): (element.style[fixer || key] = value);

							return element;
						};

						baidu.setStyle = baidu.dom.setStyle;

						baidu.dom.setStyles = function(element, styles) {
							element = baidu.dom.g(element);
							for (var key in styles) {
								baidu.dom.setStyle(element, key, styles[key]);
							}
							return element;
						};
						baidu.setStyles = baidu.dom.setStyles;
						baidu.browser = baidu.browser || {};
						baidu.browser.ie = baidu.ie = /msie (\d+\.\d+)/i.test(navigator.userAgent) ? (document.documentMode || +RegExp['\x241']) : undefined;
						baidu.dom._NAME_ATTRS = (function() {
							var result = {
								'cellpadding': 'cellPadding',
								'cellspacing': 'cellSpacing',
								'colspan': 'colSpan',
								'rowspan': 'rowSpan',
								'valign': 'vAlign',
								'usemap': 'useMap',
								'frameborder': 'frameBorder'
							};

							if (baidu.browser.ie < 8) {
								result['for'] = 'htmlFor';
								result['class'] = 'className';
							} else {
								result['htmlFor'] = 'for';
								result['className'] = 'class';
							}

							return result;
						})();
						baidu.dom.setAttr = function(element, key, value) {
							element = baidu.dom.g(element);
							if ('style' == key) {
								element.style.cssText = value;
							} else {
								key = baidu.dom._NAME_ATTRS[key] || key;
								element.setAttribute(key, value);
							}
							return element;
						};
						baidu.setAttr = baidu.dom.setAttr;
						baidu.dom.setAttrs = function(element, attributes) {
							element = baidu.dom.g(element);
							for (var key in attributes) {
								baidu.dom.setAttr(element, key, attributes[key]);
							}
							return element;
						};
						baidu.setAttrs = baidu.dom.setAttrs;
						baidu.dom.create = function(tagName, opt_attributes) {
							var el = document.createElement(tagName),
								attributes = opt_attributes || {};
							return baidu.dom.setAttrs(el, attributes);
						};
						T.undope = true;
					})();

					/**
					 * @exports InfoBox as BMapLib.InfoBox
					 */

					var InfoBox =
						/**
						 * InfoBox类的构造函数
						 * @class InfoBox <b>入口</b>。
						 * 可以自定义border,margin,padding,关闭按钮等等。
						 * @constructor
							 * @param {Map} map Baidu map的实例对象.
							 * @param {String} content infoBox中的内容.
							 * @param {Json Object} opts 可选的输入参数，非必填项。可输入选项包括：<br />
							 * {<br />"<b>offset</b>" : {Size} infoBox的偏移量
							 * <br />"<b>boxClass</b>" : {String} 定义infoBox的class,
							 * <br />"<b>boxStyle</b>" : {Json} 定义infoBox的style,此项会覆盖boxClass<br />
							 * <br />"<b>closeIconMargin</b>" : {String} 关闭按钮的margin    <br />
							 * <br />"<b>closeIconUrl</b>" : {String} 关闭按钮的url地址    <br />
							 * <br />"<b>enableAutoPan</b>" : {Boolean} 是否启动自动平移功能    <br />
							 * <br />"<b>align</b>" : {Number} 基于哪个位置进行定位，取值为[INFOBOX_AT_TOP,INFOBOX_AT_BOTTOM]<br />
							 * }<br />.
							 * @example <b>参考示例：</b><br />
							 * var infoBox = new BMapLib.InfoBox(map,"百度地图api",{boxStyle:{background:"url('tipbox.gif') no-repeat
							  center top",width: "200px"},closeIconMargin: "10px 2px 0 0",enableAutoPan: true
							  ,alignBottom: false});
						 */
						BMapLib.InfoBox = function(map, content, opts) {

							this._content = content || "";
							this._isOpen = false;
							this._map = map;

							this._opts = opts = opts || {};
							this._opts.offset = opts.offset || new BMap.Size(0, 0);
							this._opts.boxClass = opts.boxClass || "infoBox";
							this._opts.boxStyle = opts.boxStyle || {};
							//this._opts.closeIconMargin = opts.closeIconMargin || "2px";
							//this._opts.closeIconUrl = opts.closeIconUrl; // || "close.png";
							this._opts.enableAutoPan = opts.enableAutoPan ? true : false;
							this._opts.align = opts.align || INFOBOX_AT_TOP;
						}
					InfoBox.prototype = new BMap.Overlay();
					InfoBox.prototype.initialize = function(map) {
						var me = this;
						var div = this._div = baidu.dom.create('div', {
							"class": this._opts.boxClass
						});
						baidu.dom.setStyles(div, this._opts.boxStyle);
						//设置position为absolute，用于定位
						div.style.position = "absolute";
						this._setContent(this._content);

						var floatPane = map.getPanes().floatPane;
						floatPane.style.width = "auto";
						floatPane.appendChild(div);
						//设置完内容后，获取div的宽度,高度
						this._getInfoBoxSize();
						//this._boxWidth = parseInt(this._div.offsetWidth,10);
						//this._boxHeight = parseInt(this._div.offsetHeight,10);
						//阻止各种冒泡事件
						baidu.event.on(div, "onmousedown", function(e) {
							me._stopBubble(e);
						});
						baidu.event.on(div, "onmouseover", function(e) {
							me._stopBubble(e);
						});
						baidu.event.on(div, "click", function(e) {
							me._stopBubble(e);
						});
						baidu.event.on(div, "dblclick", function(e) {
							me._stopBubble(e);
						});
						return div;
					}
					InfoBox.prototype.draw = function() {
							this._isOpen && this._adjustPosition(this._point);
						}
						/**
						 * 打开infoBox
						 * @param {Marker|Point} anchor 要在哪个marker或者point上打开infobox
						 * @return none
						 *
						 * @example <b>参考示例：</b><br />
						 * infoBox.open();
						 */
					InfoBox.prototype.open = function(anchor) {
							var me = this,
								poi;
							if (!this._isOpen) {
								this._map.addOverlay(this);
								this._isOpen = true;
								//延迟10ms派发open事件，使后绑定的事件可以触发。
								setTimeout(function() {
									me._dispatchEvent(me, "open", {
										"point": me._point
									});
								}, 10);
							}
							if (anchor instanceof BMap.Point) {
								poi = anchor;
								//清除之前存在的marker事件绑定，如果存在的话
								this._removeMarkerEvt();
							} else if (anchor instanceof BMap.Marker) {
								//如果当前marker不为空，说明是第二个marker，或者第二次点open按钮,先移除掉之前绑定的事件
								if (this._marker) {
									this._removeMarkerEvt();
								}
								poi = anchor.getPosition();
								this._marker = anchor;
								!this._markerDragend && this._marker.addEventListener("dragend", this._markerDragend = function(e) {
									me._point = e.point;
									me._adjustPosition(me._point);
									me._panBox();
									me.show();
								});
								//给marker绑定dragging事件，拖动marker的时候，infoBox也跟随移动
								!this._markerDragging && this._marker.addEventListener("dragging", this._markerDragging = function() {
									me.hide();
									me._point = me._marker.getPosition();
									me._adjustPosition(me._point);
								});
							}
							//打开的时候，将infowindow显示
							this.show();
							this._point = poi;
							this._panBox();
							this._adjustPosition(this._point);
						}
						/**
						 * 关闭infoBox
						 * @return none
						 *
						 * @example <b>参考示例：</b><br />
						 * infoBox.close();
						 */
					InfoBox.prototype.close = function() {
						if (this._isOpen) {
							this._map.removeOverlay(this);
							this._remove();
							this._isOpen = false;
							this._dispatchEvent(this, "close", {
								"point": this._point
							});
						}
					}

					/**
					 * 打开infoBox时，派发事件的接口
					 * @name InfoBox#Open
					 * @event
					 * @param {Event Object} e 回调函数会返回event参数，包括以下返回值：
					 * <br />{"<b>target</b> : {BMap.Overlay} 触发事件的元素,
					 * <br />"<b>type</b>：{String} 事件类型,
					 * <br />"<b>point</b>：{Point} infoBox的打开位置}
					 *
					 * @example <b>参考示例：</b>
					 * infoBox.addEventListener("open", function(e) {
					 *     alert(e.type);
					 * });
					 */
					/**
					 * 关闭infoBox时，派发事件的接口
					 * @name InfoBox#Close
					 * @event
					 * @param {Event Object} e 回调函数会返回event参数，包括以下返回值：
					 * <br />{"<b>target</b> : {BMap.Overlay} 触发事件的元素,
					 * <br />"<b>type</b>：{String} 事件类型,
					 * <br />"<b>point</b>：{Point} infoBox的关闭位置}
					 *
					 * @example <b>参考示例：</b>
					 * infoBox.addEventListener("close", function(e) {
					 *     alert(e.type);
					 * });
					 */
					/**
					 * 启用自动平移
					 * @return none
					 *
					 * @example <b>参考示例：</b><br />
					 * infoBox.enableAutoPan();
					 */
					InfoBox.prototype.enableAutoPan = function() {
							this._opts.enableAutoPan = true;
						}
						/**
						 * 禁用自动平移
						 * @return none
						 *
						 * @example <b>参考示例：</b><br />
						 * infoBox.disableAutoPan();
						 */
					InfoBox.prototype.disableAutoPan = function() {
							this._opts.enableAutoPan = false;
						}
						/**
						 * 设置infoBox的内容
						 * @param {String|HTMLElement} content 弹出气泡中的内容
						 * @return none
						 *
						 * @example <b>参考示例：</b><br />
						 * infoBox.setContent("百度地图API");
						 */
					InfoBox.prototype.setContent = function(content) {
							this._setContent(content);
							this._getInfoBoxSize();
							this._adjustPosition(this._point);
						}
						/**
						 * 设置信息窗的地理位置
						 * @param {Point} point 设置position
						 * @return none
						 *
						 * @example <b>参考示例：</b><br />
						 * infoBox.setPosition(new BMap.Point(116.35,39.911));
						 */
					InfoBox.prototype.setPosition = function(poi) {
							this._point = poi;
							this._adjustPosition(poi);
							this._removeMarkerEvt();
						}
						/**
						 * 获得信息窗的地理位置
						 * @param none
						 * @return {Point} 信息窗的地理坐标
						 *
						 * @example <b>参考示例：</b><br />
						 * infoBox.getPosition();
						 */
					InfoBox.prototype.getPosition = function() {
							return this._point;
						}
						/**
						 * 返回信息窗口的箭头距离信息窗口在地图
						 * 上所锚定的地理坐标点的像素偏移量。
						 * @return {Size} Size
						 *
						 * @example <b>参考示例：</b><br />
						 * infoBox.getOffset();
						 */
					InfoBox.prototype.getOffset = function() {
							return this._opts.offset;
						},
						/**
						 *@ignore
						 * 删除overlay，调用Map.removeOverlay时将调用此方法，
						 * 将移除覆盖物的容器元素
						 */
						InfoBox.prototype._remove = function() {
							var me = this;
							if (this.domElement && this.domElement.parentNode) {
								//防止内存泄露
								baidu.event.un(this._div.firstChild, "click", me._closeHandler());
								this.domElement.parentNode.removeChild(this.domElement);
							}
							this.domElement = null;
							this._isOpen = false;
							this.dispatchEvent("onremove");
						},
						baidu.object.extend(InfoBox.prototype, {
							/**
							 * 获取关闭按钮的html
							 * @return IMG 关闭按钮的HTML代码
							 */
							/*
							_getCloseIcon: function() {
								var img = "<img src='" + this._opts.closeIconUrl + "' align='right' style='position:absolute;right:0px;cursor:pointer;margin:" + this._opts.closeIconMargin + "'/>";
								return img;
							},
							*/
							/**
							 * 设置infoBox的内容
							 * @param {String|HTMLElement} content 弹出气泡中的内容
							 * @return none
							 *
							 * @example <b>参考示例：</b><br />
							 * infoBox.setContent("百度地图API");
							 */
							_setContent: function(content) {
								if (!this._div) {
									return;
								}
								//var closeHtml = this._getCloseIcon();
								//string类型的content
								if (typeof content.nodeType === "undefined") {
									this._div.innerHTML = content;
								} else {
									//this._div.innerHTML = closeHtml;
									this._div.appendChild(content);
								}
								this._content = content;
								//添加click关闭infobox事件
								this._addEventToClose();

							},
							/**
							 * 调整infobox的position
							 * @return none
							 */
							_adjustPosition: function(poi) {
								var pixel = this._getPointPosition(poi);
								var icon = this._marker && this._marker.getIcon();
								switch (this._opts.align) {
									case INFOBOX_AT_TOP:
										if (this._marker) {
											this._div.style.bottom = -(pixel.y - this._opts.offset.height - icon.anchor.height + icon.infoWindowAnchor.height) - this._marker.getOffset().height + 2 + "px";
										} else {
											this._div.style.bottom = -(pixel.y - this._opts.offset.height) + "px";
										}
										break;
									case INFOBOX_AT_BOTTOM:
										if (this._marker) {
											this._div.style.top = pixel.y + this._opts.offset.height - icon.anchor.height + icon.infoWindowAnchor.height + this._marker.getOffset().height + "px";
										} else {
											this._div.style.top = pixel.y + this._opts.offset.height + "px";
										}
										break;
								}

								if (this._marker) {
									this._div.style.left = pixel.x - icon.anchor.width + this._marker.getOffset().width + icon.infoWindowAnchor.width - this._boxWidth / 2 + "px";
								} else {
									this._div.style.left = pixel.x - this._boxWidth / 2 + "px";
								}
							},
							/**
							 * 得到infobox的position
							 * @return Point  infobox当前的position
							 */
							_getPointPosition: function(poi) {
								this._pointPosition = this._map.pointToOverlayPixel(poi);
								return this._pointPosition;
							},
							/**
							 * 得到infobox的高度跟宽度
							 * @return none
							 */
							_getInfoBoxSize: function() {
								this._boxWidth = parseInt(this._div.offsetWidth, 10);
								this._boxHeight = parseInt(this._div.offsetHeight, 10);
							},
							/**
							 * 添加关闭事件
							 * @return none
							 */
							_addEventToClose: function() {
								var me = this;
								baidu.event.on(this._div.firstChild, "click", me._closeHandler());
								this._hasBindEventClose = true;
							},
							/**
							 * 处理关闭事件
							 * @return none
							 */
							_closeHandler: function() {
								var me = this;
								return function(e) {
									me.close();
								}
							},
							/**
							 * 阻止事件冒泡
							 * @return none
							 */
							_stopBubble: function(e) {
								if (e && e.stopPropagation) {
									e.stopPropagation();
								} else {
									window.event.cancelBubble = true;
								}
							},
							/**
							 * 自动平移infobox，使其在视野中全部显示
							 * @return none
							 */
							_panBox: function() {
								if (!this._opts.enableAutoPan) {
									return;
								}
								var mapH = parseInt(this._map.getContainer().offsetHeight, 10),
									mapW = parseInt(this._map.getContainer().offsetWidth, 10),
									boxH = this._boxHeight,
									boxW = this._boxWidth;
								//infobox窗口本身的宽度或者高度超过map container
								if (boxH >= mapH || boxW >= mapW) {
									return;
								}
								//如果point不在可视区域内
								if (!this._map.getBounds().containsPoint(this._point)) {
									this._map.setCenter(this._point);
								}
								var anchorPos = this._map.pointToPixel(this._point),
									panTop, panBottom, panY,
									//左侧超出
									panLeft = boxW / 2 - anchorPos.x,
									//右侧超出
									panRight = boxW / 2 + anchorPos.x - mapW;
								if (this._marker) {
									var icon = this._marker.getIcon();
								}
								//基于bottom定位，也就是infoBox在上方的情况
								switch (this._opts.align) {
									case INFOBOX_AT_TOP:
										//上侧超出
										var h = this._marker ? icon.anchor.height + this._marker.getOffset().height - icon.infoWindowAnchor.height : 0;
										panTop = boxH - anchorPos.y + this._opts.offset.height + h + 2;
										break;
									case INFOBOX_AT_BOTTOM:
										//下侧超出
										var h = this._marker ? -icon.anchor.height + icon.infoWindowAnchor.height + this._marker.getOffset().height + this._opts.offset.height : 0;
										panBottom = boxH + anchorPos.y - mapH + h + 4;
										break;
								}

								panX = panLeft > 0 ? panLeft : (panRight > 0 ? -panRight : 0);
								panY = panTop > 0 ? panTop : (panBottom > 0 ? -panBottom : 0);
								this._map.panBy(panX, panY);
							},
							_removeMarkerEvt: function() {
								this._markerDragend && this._marker.removeEventListener("dragend", this._markerDragend);
								this._markerDragging && this._marker.removeEventListener("dragging", this._markerDragging);
								this._markerDragend = this._markerDragging = null;
							},
							/**
							 * 集中派发事件函数
							 *
							 * @private
							 * @param {Object} instance 派发事件的实例
							 * @param {String} type 派发的事件名
							 * @param {Json} opts 派发事件里添加的参数，可选
							 */
							_dispatchEvent: function(instance, type, opts) {
								type.indexOf("on") != 0 && (type = "on" + type);
								var event = new baidu.lang.Event(type);
								if (!!opts) {
									for (var p in opts) {
										event[p] = opts[p];
									}
								}
								instance.dispatchEvent(event);
							}
						});
				})();
			

			var firstTime = true; // REQ-048
			var BaiduMaps = {
				options: {
					country: 'cn',
					zoomLevel: 11, // 10
					zoomLevelMin: 2,
					zoomLevelMax: 24,
					viewport: null,
					countryRestriction: true,
					queryZoomLevel: 11, // 10
					queryUrl: $('#storeSearchForm').attr('action'),
					queryType: "json",
					unitMetric: false,
					useDirection: false,
					centerLatitude: null,
					centerLongitude: null,
					defaultLatitude: $('.find-locally-cn').data('default-latitude'), // REQ-048
					defaultLongitude: $('.find-locally-cn').data('default-longitude'), // REQ-048
					useController: false,
					debug: false,
					unit: 'Mile', //metric(Km), imperial(Mile)
					distance: 25//,
					//distance_opt: "5,10,25,50"
				},
				init: function() {
					var self = this;
					self.region = $('#province').val();
					self.city = $('#city').val();
					self.superCategory = $('#superCategory').val();
					self.category = $('#category').val();
					self.map;
					self.center;
					self.searchPosition;
					self.activeItem;
					self.page;
					self.infobox;
					self.listOpen = false;
					self.markers = [];
					self.stores = [];
					self.storeSort;
					self.brandPage = false;
					self.geolocation;

					self.infoOptions = {
						alignBottom: true,
						disableAutoPan: true,
						enableAutoPan: false,
						offset : ($(window).width()<768) ? new BMap.Size(0, 0) : new BMap.Size(0, 0),
						zIndex: 99,
						boxStyle: {
							width: ($(window).width()<768) ? "300px":"360px"
						},
						infoBoxClearance: {
							"width" : 1,
							"height" : 1
						},
						enableEventPropagation: true,
						boxClass:  ($(window).width()<768) ? "info-window small" : "info-window"
					};

					self.mapSetting();
				},
				mapSetting : function() {
					var self = this;
					var ctrl_nav,
						ctrl_ove,
						ctrl_sca;

					self.map = new BMap.Map('storeMap');
					ctrl_nav = new BMap.NavigationControl({
						anchor: BMAP_ANCHOR_TOP_RIGHT, // BMAP_ANCHOR_TOP_LEFT
						type: BMAP_NAVIGATION_CONTROL_LARGE // BMAP_NAVIGATION_CONTROL_SMALL, BMAP_NAVIGATION_CONTROL_LARGE, BMAP_NAVIGATION_CONTROL_ZOOM, BMAP_NAVIGATION_CONTROL_PAN
					});
					if($(window).width()>=768){
						ctrl_ove = new BMap.OverviewMapControl({
							anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
							isOpen: false
						});
					}
					/*//LGECN-2310 : 20180718 modify*/
					ctrl_sca = new BMap.ScaleControl({
						anchor: BMAP_ANCHOR_BOTTOM_LEFT
					});
					self.map.enableScrollWheelZoom(); // true
					self.map.enableDoubleClickZoom();
					self.map.addControl(ctrl_nav);
					self.map.addControl(ctrl_ove);
					self.map.addControl(ctrl_sca);
					//self.map.addControl(new BMap.MapTypeControl());

					self.addEvent();

					// 아래 구문을 넣으면, NavigationControl과 OverviewMapControl 에서 오류가 발생합니다.
					/*
					self.map.addEventListener = function(event, fun) {
						if (event == "moveend" || event == "mousemove") {
							return false;
						} else {
							this['on' + event] = fun;
						}
					}
					*/
					if(firstTime) {
						firstTime = false;
						self.map.centerAndZoom(new BMap.Point(self.options.defaultLongitude, self.options.defaultLatitude),self.options.zoomLevel); 
					} else {
						self.map.centerAndZoom(new BMap.Point(116.4035,39.915),self.options.zoomLevel);
					}

					// baidu logo
					//setTimeout(function() {
					//	$('.anchorBL').eq(0).remove();
					//}, 500);

					self.markerCss = {
						origin : {background:"url(http://api0.map.bdimg.com/images/dest_markers.png) no-repeat"},
						destination : {background:"url(http://api0.map.bdimg.com/images/dest_markers.png) no-repeat 0 -34px"}
					}

				},
				addEvent: function() {
					var self = this;

					self.$localStore = $(".find-locally-cn");
					self.$searchForm = self.$localStore.find('.searchbox form');
					self.$storeSection = self.$localStore.find('.information-on-map');
					self.$toggleBtn = self.$localStore.find('.btn-collapse');
					self.$resultBox = self.$localStore.find('.result-box');
					self.$directionBox = self.$localStore.find('.direction-box');
					self.$storeList = self.$localStore.find("#storeResult .result-list");
					self.$searchInput = self.$localStore.find('#mapSearch');
					self.$storeSearchForm = self.$localStore.find('#storeSearchForm');
					self.$resultLocation = self.$localStore.find('.search-location'); // select a location 텍스트 영역
					self.$directionsForm = self.$localStore.find('#directionForm');
					self.$storeMapArea = self.$localStore.find('#storeMap');
					self.$routeList = self.$localStore.find("#directionRoute");

					self.locaitonKey = document.getElementById("startInput");
					self.hasSearchInput = self.$localStore.find('.search-results .search-area.type-store').hasClass('active');
					self.hasSearchSubmit = (self.$localStore.find('.searchbox-wrap .select-box button[type=submit]').length>0) ? true:false;

					self.$defaultMsg = self.$resultBox.find(".default-msg");
					self.$noItems = self.$resultBox.find(".no-items");
					self.$btnArea = self.$resultBox.find(".btn-area");

					self.$locationBtn = self.$localStore.find('button.location');

					self.templateList = self.$storeList.find('template.list').clone().html();
					self.templateMap = self.$storeList.find('template.map').clone().html();
					self.templatePage = self.$btnArea.find('template.page').clone().html();

					self.$storeList.find('template.list').remove();
					self.$storeList.find('template.map').remove();
					self.$storeList.find('template.page').remove();

					self.options.useBrand = (self.$resultBox.find('.tabs-type-liner').length>0) ? true : false;

					if(!self.options.useBrand) {
						self.$localStore.addClass('no-tab');
					}

					//self.options.unit = self.$searchForm.children("[name=distanceType]").val() == "mi" ? "Mile" : "Km";
					//if (self.options.unit == "Km") self.options.unitMetric = true;
					//if ($(".map-store-distance").length > 0) {
					//	self.options.distance = self.$searchForm.children("[name=distance_init]").val();
					//}

					self.geoResult = {};
					self.markers = [];
					self.activeItem;
					self.searchHandle = false;
					self.openDirection = false;
					self.distance = self.options.distance;
					self.afterControl = false;

					self.timing = {
						queryTimeout: null
					};
					// province && city
					self.$province = self.$localStore.find('select[id=province]');
					var provinceParam = self.$province.data('param');
					if(provinceParam) {
						self.$province.find('option[value]').each(function() {
							var v = $(this).val();
							$(this).attr('data-param', provinceParam+'&state='+v);
						});
					}
					self.$province.drawAjaxOptions({
						dynamicParam: true,
						url: self.$province.data('url'),
						setTarget: document.getElementById('city')
					});
					self.$province.on('change', function() {
						self.region = $(this).val();
						self.city = "all";
						self.$storeSearchForm.find('input[name=region]').val(self.region);
						self.$storeSearchForm.find('input[name=city]').val(self.city);
					});
					self.$city = self.$localStore.find('select[id=city]');
					self.$city.on('change', function() {
						self.city = $(this).val();
						self.$storeSearchForm.find('input[name=region]').val(self.region);
						self.$storeSearchForm.find('input[name=city]').val(self.city);
					});
					// super category && category
					self.$supercategory = self.$localStore.find('select[id=superCategory]');
					var supercategoryParam = self.$supercategory.data('param');
					if(supercategoryParam) {
						self.$supercategory.find('option[value]').each(function() {
							var v = $(this).val();
							$(this).attr('data-param', supercategoryParam+'&state='+v);
						});
					}
					self.$supercategory.drawAjaxOptions({
						dynamicParam: true,
						url: self.$supercategory.data('url'),
						setTarget: document.getElementById('category')
					});
					self.$supercategory.on('change', function() {
						self.superCategory = $(this).val();
						self.category = 'all';
						self.$storeSearchForm.find('input[name=superCategory]').val(self.superCategory);
						self.$storeSearchForm.find('input[name=category]').val(self.category);
					});
					self.$category = self.$localStore.find('select[id=category]');
					self.$category.on('change', function() {
						self.category = $(this).val();
						self.$storeSearchForm.find('input[name=superCategory]').val(self.superCategory);
						self.$storeSearchForm.find('input[name=category]').val(self.category);
					});

					/* LGECN-106 : 20210128 add */
					// default search option setting
					self.$province.val('北京市').prop("selected", true).trigger('change');
					// LGECN-174
					self.$searchForm.find('select[id=city]').each(function (){
						$(this).val('all').prop("selected", true).trigger('change');
					});
					// LGECN-174 End
					self.$searchForm.find('select').each(function (){
						$(this).trigger('chosen:updated');
					});
					setTimeout(function(){
						self.$localStore.find('.searchbox-wrap .submit-box button[type=submit]').trigger('click');
					}, 500);
					/*//LGECN-106 : 20210128 add */

					$('.GPC0102').on('click', '.get-direction', function(e) {
						e.preventDefault();
						self.openDirection = true;

						// for design
						self.$resultBox.removeClass('active');
						self.$directionBox.addClass('active');
						self.$localStore.find('.search-results .search-area.type-store').removeClass('active');
						self.$localStore.find('.search-results .search-area.type-direction').addClass('active');

						// layer on map
						self.onItem($(this).data('num'));

						// address
						var address = $(this).closest('.btns').siblings('.address').text();
						$(this).closest('.find-locally-cn').find('.search-area.type-direction .to div.input').text(address);

						self.setDirection(self.activeItem);
					});

					$('.GPC0102').on('click', '.search-area.type-direction .close a', function(e) {
						e.preventDefault();
						var itemNum = self.activeItem;

						self.reset();
						
						// for design
						self.$resultBox.addClass('active');
						self.$directionBox.removeClass('active');
						if(self.hasSearchInput) self.$localStore.find('.search-results .search-area.type-store').addClass('active')
						self.$localStore.find('.search-results .search-area.type-direction').removeClass('active');

						$('#startInput').val('');
						self.openDirection = false;

						setTimeout(function() {
							self.addAllMarkers(self.data);
							self.$resultBox.find('.tabs-cont.active div.list-box[data-item='+itemNum+'] .view-detail-map').trigger('click');;
						}, 100);

					});

					$('.GPC0102').on('click', '.list-box .view-detail-map', function(e) {
						e.preventDefault();
						e.stopPropagation();
						var item = $(this).closest('.list-box').data('item');
						self.onItem(item);
					});

					$('.GPC0102').on('click', 'a.window-close', function(e) {
						e.preventDefault();
						self.infobox.close();
					});

					self.$locationBtn.on('click', function(e) {
						e.preventDefault();
						self.geolocation = new BMap.Geolocation();
						self.getMyLocation();
					});

					//layer toggle event
					self.$toggleBtn.on('click', function(e) {
						e.preventDefault();
						var list = self.$storeSection;
						$(this).toggleClass('active');
						list.toggleClass('active');
						self.$localStore.find('.search-results').toggleClass('active');
						self.resizing();
					});

					self.$storeSearchForm.on('submit', $.proxy(self.searchAddress, self));
					self.$directionsForm.on('submit', $.proxy(self.setDirectionPanel, self));

					$(self.locaitonKey).on('change input', function(e) {
						e.preventDefault();
						//self.$directionsForm.submit();
						setTimeout(function() {
							self.$directionsForm.find('input.submit').click();
						}, 200);
					})

					// submit button
					self.$localStore.find('.searchbox form .submit-box button.btn.btn-primary').on('click', function(e) {
						e.preventDefault();
						
						// for design
						self.$resultBox.addClass('active');
						self.$storeSection.addClass('active');
						self.$directionBox.removeClass('active');
						self.$localStore.find('.search-results').addClass('active');
						if(self.hasSearchInput) self.$localStore.find('.search-results .search-area.type-store').addClass('active');
						self.$localStore.find('.search-results .search-area.type-direction').removeClass('active');

						// submit
						self.$storeSearchForm.submit();
					});

					if(typeof self.$storeSearchForm.get(0).length == "object") {
						var itemLength;
						if(isMobile) {
							itemLength = self.$storeSearchForm.get(0).length.getAttribute('data-mobile');
						}else {
							itemLength = self.$storeSearchForm.get(0).length.getAttribute('data-desktop');
						}
						self.$storeSearchForm.get(0).length.value = itemLength;
					}

					// pagination 
					$('.GPC0102').on('click', '.find-locally-cn .btn-area .pagination a, .find-locally-cn .btn-area .pagination button', function(e) {
						e.preventDefault();
						
						/* 20210209 : LGEITF-257 add */ 
						if ($(this).attr('disabled')) return false;
						/* //20210209 : LGEITF-257 add */ 
						
						self.$storeSearchForm.get(0).page.value = $(this).val() || $(this).attr('value');
						var param = self.$storeSearchForm.serialize();
						self.pageAjax(self.options.queryUrl, param);
					});

				},
				searchAddress: function(e) {
					e.preventDefault();
					var self = this,
						keyword;

					self.reset();

					// 20200512 START 박지영 : 검색 시 지도 위치 수정 

					var address = '';
					var region = self.region;
					var city = self.city;

					self.geocoder = new BMap.Geocoder();

					var option = {
						onSearchComplete: function(results) {
							// console.log(3, self.searchPosition.getStatus(), BMAP_STATUS_SUCCESS, results);
							if (self.searchPosition.getStatus() == BMAP_STATUS_SUCCESS) {
								self.map.centerAndZoom(results.getPoi(0).point, 11);
								self.center = self.map.getCenter();
								self.$resultLocation.text(address);
								var param = self.$storeSearchForm.serialize();
								self.pageAjax(self.options.queryUrl, param);
								self.afterControl = true;
							}
						}
					};
					self.searchPosition = new BMap.LocalSearch(self.map, option);
					if (typeof(region) != "undefined") {
						if (typeof(city) != "undefined") {
							if (region == "all" && city == "all") {
								keyword = self.options.region;
							} else if (city != "all") {
								keyword = city;
							} else {
								keyword = region;
							}
						}
					}
					if(!keyword) keyword = '北京市';
					self.searchPosition.search(keyword);

					var slist = $(".store-list", self.$storeSearchForm);
					if($('.navigation').length>0 && !$('.navigation').is('.mobile-device')) {
						setTimeout(function() {
							if($(window).width()<768) {
								if(slist.hasClass('mCustomScrollbar')) slist.mCustomScrollbar('disable', true);
							} else {
								//if(slist.hasClass('mCustomScrollbar')) slist.mCustomScrollbar('disable', false);
								if(slist.hasClass('mCustomScrollbar')) slist.mCustomScrollbar('update');
							}
						}, 500);
					}

					// 20200512 END

				},
				pageAjax: function(url, param, toggleContent) {
					var self = this;
					//var $box = $(".store-map-wrap > li[data-index]").length ? $("li[data-index="+ self.storeSort +"]").find(".store-map-box") : self.$storeMapArea;
					//var target = $box.find(".offline-store-list").length ? ".offline-store-list" : ".store-map-box";

					if( typeof(param) != "undefined" && typeof(self.storeSort) != "undefined"){
						param.sort = self.storeSort;
					}

					$('.GPC0102 .map-container').trigger('ajaxLoadBefore');
					$.ajax({
						type: 'post',
						url: url,
						data: typeof(param) != "undefined" ? xssfilter(param) : {},
						dataType: self.options.queryType,
						error: function(xhr) {
							self.queryError();
						},
						success: function(d) { // data
							self.map.process = true;
							//self.markers = [];
							self.stores = [];

							// 20200427 START 박지영 - 검색 시 마커 모두 삭제 
							for (var i = 0; i < self.markers.length; i++) {
								self.map.removeOverlay(self.markers[i]);
							}
							// 20200427 END

							if(d) {
								if(d.data) data = d.data instanceof Array ? d.data[0] : d.data;
								else data = d;
								data.marker = ""; //LGEGMC-2455
								var dataLen = data.distributors.length;
								if (dataLen) {
									//var curBounds = new google.maps.LatLngBounds();
									var insetMarker = 0;

									self.data = data.distributors;

									//list reset
									self.$storeList.addClass('active');
									self.$storeList.siblings('.btn-area').removeClass('active');
									self.$storeList.siblings('.default-msg').removeClass('active');
									self.$storeList.siblings('.no-items').removeClass('active');

									//self.$brandList.data('brand-count', 0);

									// 20200512 START 박지영 - 불필요한 JS 삭제 
									//var searchPoint = new BMap.Point(self.geoResult.locations.lng,self.geoResult.locations.lat);
									//console.log(searchPoint);
									// 20200512 END
									var compareDistance = self.options.unit == "Mile" ? self.distance*1609.344 : self.distance*1000;
									var index = 0;
									var newData = [];

									// marker
									self.addAllMarkers(data.distributors);
									$.each(data.distributors, function(item) {
										self.stores.push(data.distributors[item]);
									});

									// list
									self.$storeList.find('div.list').empty();
									for(var i=0;i<dataLen;i++) {
										self.setStoreList(data.distributors, i); // 5.0
									}

									// pagination
									var pageInfo = data.pageInfo;
									if(pageInfo) {
										// for mobile view
										self.$btnArea.find('.pagination.visible-xs .prev').attr('disabled', !pageInfo.leftPage).attr('value', pageInfo.page-1);
										self.$btnArea.find('.pagination.visible-xs .next').attr('disabled', !pageInfo.rightPage).attr('value', pageInfo.page+1);
										self.$btnArea.find('.pagination.visible-xs').find('.page-counter .current-page').text(pageInfo.page);
										self.$btnArea.find('.pagination.visible-xs').find('.page-counter .total-page').text(pageInfo.pageCount);

										// for desktop view
										self.$btnArea.find('.pagination.hidden-xs .prev').attr('disabled', !pageInfo.leftPage).attr('value', pageInfo.page-1);
										self.$btnArea.find('.pagination.hidden-xs .next').attr('disabled', !pageInfo.rightPage).attr('value', pageInfo.page+1);
										var pageMarkup = [];
										for (var pageIdx = pageInfo.loopStart; pageIdx <= pageInfo.loopEnd; pageIdx++) {
											var _pageItem = self.templatePage;
											_pageItem = $(_pageItem).get(0);
											var _pageButton = _pageItem.querySelector('button');
											_pageButton.value = pageIdx;
											_pageButton.innerHTML = pageIdx;
											if(pageIdx.toString() == pageInfo.page) {
												_pageButton.setAttribute('class', 'active');
												_pageButton.setAttribute('aria-current', 'page');
											}
											if(self.$btnArea.find('.pagination.hidden-xs').attr('data-aria-pattern')) {
												var _ariaText = self.$btnArea.find('.pagination.hidden-xs').attr('data-aria-pattern').replace(/\#/g, pageIdx);
												_pageButton.setAttribute('aria-label', _ariaText);
											}
											pageMarkup += _pageItem.outerHTML;
										}
										self.$btnArea.find('.pagination.hidden-xs ul').html(pageMarkup); 

									}

									self.$btnArea.addClass('active');

								} else {
									if(d.businessErrorFlag=="Y" && d.redirectUrl != null) {
										location.href=d.redirectUrl;
									} else {
										// self.reset();
										self.setErrorList();
										// self.queryError(); - reset + setErrorList
									}
								}
							} else {
								if(d.businessErrorFlag=="Y" && d.redirectUrl != null) {
									location.href=d.redirectUrl;
								} else {
									//self.reset();
									self.setErrorList();

									// self.queryError(); - reset + setErrorList
								}
							}
							self.map.process = false;
						},
						complete: function() {
							self.searchHandle = false;
							$('.GPC0102 .map-container').trigger('ajaxLoadEnd');
						}
					});
				},
				addAllMarkers : function(data) {
					var self = this;
					// marker
					$.each(data, function(item) {
						var point = data[item].wtbAddress;
						var icons;
						if ($(window).width()<768) {
							//item = item + (self.page - 1) * 5;
							icons = new BMap.Icon("/lg5-common-gp/images/customer/mark-" + (parseInt(item, 10) + 101).toString().substr(1) + ".png", new BMap.Size(30, 43));
						} else {
							icons = new BMap.Icon("/lg5-common-gp/images/customer/mark-" + (parseInt(item, 10) + 101).toString().substr(1) + ".png", new BMap.Size(30, 43), {
								//imageOffset: new BMap.Size(0, 0 - item * 43)
							});
						}
						// 20200421 START 박지영 - CN 위도와 경도 존재하는 경우 처리
						if(data[item].wtbLatitudeValue != null && data[item].wtbLongitudeValue != null) {
							// 20200427 START 박지영 - 위경도 변경
							var pointStatic = new BMap.Point(data[item].wtbLongitudeValue, data[item].wtbLatitudeValue);
							// 20200427 END
							self.addMarkers(pointStatic, icons, item);
						} else {
							var pointGeo = new BMap.Geocoder();
							pointGeo.getPoint(point, function(position) {
								if (position) {
									self.addMarkers(position, icons, item);
								}
							});
						}
						// 20200421 END
					});
				},
				addMarkers : function(point, icons, itemNumber) {
					var self = this;
					var marker = new BMap.Marker(point, {
						icon: icons,
					});
					self.markers[itemNumber] = marker;
					self.map.addOverlay(marker);

					marker.addEventListener("click", function() {
						self.onItem(itemNumber);
						self.focusList(itemNumber);
						marker.setTop(true);
						// self.activeItem
					});
					marker.addEventListener("mouseover", function() {
						marker.setTop(true);
					});
					marker.addEventListener("mouseout", function() {
						marker.setTop(false);
					});
				},
				onItem : function(item) {
					//console.log('onItem', item, typeof(item));
					var self = this;
					$("div.list-box", "#storeResult").removeClass("active").filter("div.list-box[data-item='" + item + "']").addClass("active");

					if (typeof(item) == "undefined") {
						if (typeof(self.infobox) != "undefined"){
							if(self.infobox._isOpen){
								self.infobox.close();
							}
						}
						self.activeItem = null;
					} else if (self.activeItem != item) {
						if (typeof(self.infobox) != "undefined"){
							 if(self.infobox._isOpen){
								self.infobox.close();
							 }
						}
						self.activeItem = item;
						self.setStoreInfo(item);
						self.map.panTo(self.markers[item].getPosition());
						self.center = self.map.getCenter();
						self.infobox.open(self.markers[item].getPosition());
					} else if (self.activeItem == item && !self.infobox._isOpen) {
						self.setStoreInfo(item);
						//if($(window).width()>768){
						self.map.panTo(self.markers[item].getPosition());
						self.center = self.map.getCenter();
						//}
						setTimeout(function() {
							self.infobox.open(self.markers[item].getPosition());
						}, 100);
					} else if (self.activeItem == item && self.infobox._isOpen) {
						self.map.panTo(self.markers[item].getPosition());
						self.center = self.map.getCenter();
					}

					//if(self.activeItem != null) {
						//console.log(self.markers[item].getPosition());
					//}

					setTimeout(function() {
						if(self.$storeMapArea.find(".infowindow-wrap").length>0) self.$storeMapArea.find(".infowindow-wrap").off();
						if(self.$storeMapArea.find(".infowindowp").length>0) self.$storeMapArea.find(".infowindow").off();
						
					}, 500);
				},
				focusList : function(item, callback) {
					//console.log(item);
					if ($(window).width()<768) return;
					if($('.navigation').length>0 && !$('.navigation').is('.mobile-device')) {
						var slist = $(".result-list", self.$storeSection);
						slist.mCustomScrollbar("scrollTo", slist.find('.mCSB_container .list .list-box:eq('+item+')'));
					}
				},
				setDirection : function(item) {
					var self = this;
					var startInput = document.getElementById("startInput");
					self.$routeList.html(null);

					if (self.openDirection) {

						var data = self.stores[item];

						// 마커 제어하기
						for (var i = 0; i < self.markers.length; i++) {
							if(i==item) {
								self.map.addOverlay(self.markers[i]);
							} else {
								self.map.removeOverlay(self.markers[i]);
							}
						}

						setTimeout(function() {
							self.autoZipcode('startInput');
						}, 100);

					}
				},
				//autocomplet input
				autoZipcode : function(element) {
					var self = this;
					self.autoComplete = new BMap.Autocomplete({
						"input" : element
						,"location" : self.map
					});
					self.autoComplete.addEventListener("onhighlight", function(e) {
						var str = "";
						var _value = e.fromitem.value;
						var value = "";
						if (e.fromitem.index > -1) {
							value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
						}
						str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
						value = "";
						if (e.toitem.index > -1) {
							_value = e.toitem.value;
							value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
						}    
						str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
					});
					var myValue;
					self.autoComplete.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
						var _value = e.item.value;
						myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
					});
				},
				setDirectionPanel : function(e) {
					var self = this;
					e.preventDefault();

					var options = {
						renderOptions: {
							map: self.map,
							panel: "directionRoute",
							autoViewport: true
						},
						onSearchComplete: function(results){
							if (driving.getStatus() === 0){

								self.$routeList.addClass('active');
								self.$routeList.siblings('.direction-title').removeClass('active');
								self.$routeList.siblings('.default-msg').removeClass('active');
								self.$routeList.siblings('.no-items').removeClass('active');

								setTimeout(function() {
									self.$storeMapArea.find(".BMap_Marker.BMap_noprint").css(self.markerCss.origin);
									self.$storeMapArea.find(".BMap_Marker.BMap_noprint").last().css(self.markerCss.destination);
								},100);
							} else {
								self.reset();
								self.$routeList.removeClass('active');
								self.$routeList.siblings('.direction-title').removeClass('active');
								self.$routeList.siblings('.default-msg').removeClass('active');
								self.$routeList.siblings('.no-items').addClass('active');
							}
						}
					}
					
					var driving = new BMap.DrivingRoute(self.map, options);
					self.geocoder.getPoint(document.getElementById("startInput").value,function(point){
						if(point){
							self.geocoder.getPoint(self.options.centerAddr,function(point2){
								if(point2){
									self.map.clearOverlays();
									driving.search(point, point2);
								} else{
									self.reset();
									self.$routeList.removeClass('active');
									self.$routeList.siblings('.direction-title').removeClass('active');
									self.$routeList.siblings('.default-msg').removeClass('active');
									self.$routeList.siblings('.no-items').addClass('active');
								}
							})
						} else{
							self.reset();
							self.$routeList.removeClass('active');
							self.$routeList.siblings('.direction-title').removeClass('active');
							self.$routeList.siblings('.default-msg').removeClass('active');
							self.$routeList.siblings('.no-items').addClass('active');
						}
					});
				},
				getMyLocation : function() {
					var self = this;
					if ($(this).siblings('input[type=text]').attr('disabled') == 'disabled') {return;}

					self.geocoder = new BMap.Geocoder();
					function geoError(err) {
						//console.log(error);
						if(err) console.log(err.code, err.message);
						// alert('Geolocation is not supported for this Browser/OS.');
						if($('#geoLocationError').length>0) $('#geoLocationError').modal();
					}
					if (self.options.country == null) {
						// no country
						self.$storeList.removeClass('active');
						self.$defaultMsg.addClass('active');
						self.$noItems.removeClass('active');
						self.$btnArea.removeClass('active');
						return;
					}
					if (self.geolocation) {
						self.geolocation.getCurrentPosition(function(r){
							if(this.getStatus() == BMAP_STATUS_SUCCESS){
								var mk = new BMap.Marker(r.point);
								self.map.addOverlay(mk);
								self.map.panTo(r.point);
								var point = new BMap.Point(r.point.lng,r.point.lat);
								self.map.centerAndZoom(point,12);
								console.log('self.geoResult.locations', self.geoResult.locations);
								self.geocoder.getLocation(point, $.proxy(function(location) {
									var addComp = location.addressComponents;
									var address = "";
									for(var add in addComp){
										if(add == "province") continue
										address = addComp[add] ? addComp[add] +" " + address : address
									}
									console.log(address);
									if (!self.openDirection) {
										document.getElementById("mapSearch").value = address
									} else {
										document.getElementById("startInput").value = address
									}
								}, this));
							}
						}, geoError, {enableHighAccuracy: true})
					} else {
						geoError();
					}
				},
				setErrorList : function() {
					var self = this;
					self.$storeList.removeClass('active');
					self.$defaultMsg.removeClass('active');
					self.$btnArea.removeClass('active');
					self.$noItems.addClass('active');
				},
				queryError : function(){
					var self = this;
					self.reset();
					self.setErrorList();
				},
				reset : function() {
					var self = this;
					if (!self.openDirection) {
						//self.markers = [];
						self.map.clearOverlays();
						self.onItem();
						self.activeItem = null;

						self.$storeList.removeClass('active');
						self.$defaultMsg.addClass('active');
						self.$btnArea.removeClass('active');
						self.$noItems.removeClass('active');

					} else {
						self.map.clearOverlays();
						//self.setCountry(self.options.centerAddr);
						/*
						self.geocoder.getPoint(self.options.centerAddr, $.proxy(function (point) {
							self.map.centerAndZoom(point, 14);
							var myIcon = new BMap.Icon("/cn/content/img/support/repair/marker_default.png", new BMap.Size(25, 37));
							var marker = new BMap.Marker(point,{icon:myIcon});
							self.map.addOverlay(marker); // 将标注添加到地图中
						}, this));
						*/
						if (typeof(self.infobox) != "undefined"){
							 if(self.infobox._isOpen){
								self.infobox.close();
							 }
						}

						self.$routeList.removeClass('active');
						self.$routeList.siblings('.direction-title').removeClass('active');
						self.$routeList.siblings('.default-msg').addClass('active');
						self.$routeList.siblings('.no-items').removeClass('active');
					}
				},
				resizing : function() {
					var self = this;
					self.center = self.map.getCenter();
					setTimeout(function() {
						self.map.setCenter(self.center);
					}, 100);
				},
				//map infoBox panel make
				setStoreInfo : function(itemNum) {
					var self = BaiduMaps;
					var data = self.data;
					var content = this.templateMap
								.replace(/\*itemNum\*/g, itemNum)
								.replace(/\*itemNum2\*/g, (parseInt(itemNum)+1))
								.replace(/\*distributorId\*/g, data[itemNum]["distributorId"])
								.replace(/\*distributorTypeCode\*/g, data[itemNum]["distributorTypeCode"])
								.replace(/\*wtbName\*/g, data[itemNum]["wtbName"])
								.replace(/\*wtbAddress\*/g, data[itemNum]["wtbAddress"])
								.replace(/\*stateCode\*/g, data[itemNum]["stateCode"])
								.replace(/\*stateName\*/g, data[itemNum]["stateName"])
								.replace(/\*stateCodeSort\*/g, data[itemNum]["stateCodeSort"])
								.replace(/\*cityName\*/g, data[itemNum]["cityName"])
								.replace(/\*addressLine1Info\*/g, data[itemNum]["addressLine1Info"])
								.replace(/\*addressLine2Info\*/g, data[itemNum]["addressLine2Info"])
								.replace(/\*addressLine3Info\*/g, data[itemNum]["addressLine3Info"])
								.replace(/\*addressLine4Info\*/g, data[itemNum]["addressLine4Info"])
								.replace(/\*postalCode\*/g, data[itemNum]["postalCode"])
								.replace(/\*wtbPhoneNo\*/g, data[itemNum]["wtbPhoneNo"])
								.replace(/\*phone2No\*/g, data[itemNum]["phone2No"])
								.replace(/\*faxNo\*/g, data[itemNum]["faxNo"])
								.replace(/\*siteUrlAddr\*/g, data[itemNum]["siteUrlAddr"])
								.replace(/\*emailAddr\*/g, data[itemNum]["emailAddr"])
								.replace(/\*wtbLatitudeValue\*/g, data[itemNum]["wtbLatitudeValue"])
								.replace(/\*wtbLongitudeValue\*/g, data[itemNum]["wtbLongitudeValue"])
								.replace(/\*brandShopFlag\*/g, data[itemNum]["brandShopFlag"])
								.replace(/\*dealerSize\*/g, data[itemNum]["dealerSize"])
								;
					var $template = $(content),
						$keyBlocks = $template.find('*[data-key]');

					for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
						var $currentKeyBlock = $keyBlocks.eq(i1),
							key = $currentKeyBlock.get(0).getAttribute('data-key'),
							val = data[itemNum][key];
						if(!val || val==null) {
							$currentKeyBlock.remove();
						}
					}
					var template = $template.get(0).outerHTML;
					self.infobox = new BMapLib.InfoBox(self.map, template, self.infoOptions);
				},
				setStoreList : function(data, itemNum) {
					var self = this;
					var content = self.templateList
								.replace(/\*itemNum\*/g, itemNum)
								.replace(/\*itemNum2\*/g, (parseInt(itemNum)+1))
								.replace(/\*distributorId\*/g, data[itemNum]["distributorId"])
								.replace(/\*distributorTypeCode\*/g, data[itemNum]["distributorTypeCode"])
								.replace(/\*wtbName\*/g, data[itemNum]["wtbName"])
								.replace(/\*wtbAddress\*/g, data[itemNum]["wtbAddress"])
								.replace(/\*stateCode\*/g, data[itemNum]["stateCode"])
								.replace(/\*stateName\*/g, data[itemNum]["stateName"])
								.replace(/\*stateCodeSort\*/g, data[itemNum]["stateCodeSort"])
								.replace(/\*cityName\*/g, data[itemNum]["cityName"])
								.replace(/\*addressLine1Info\*/g, data[itemNum]["addressLine1Info"])
								.replace(/\*addressLine2Info\*/g, data[itemNum]["addressLine2Info"])
								.replace(/\*addressLine3Info\*/g, data[itemNum]["addressLine3Info"])
								.replace(/\*addressLine4Info\*/g, data[itemNum]["addressLine4Info"])
								.replace(/\*postalCode\*/g, data[itemNum]["postalCode"])
								.replace(/\*wtbPhoneNo\*/g, data[itemNum]["wtbPhoneNo"])
								.replace(/\*phone2No\*/g, data[itemNum]["phone2No"])
								.replace(/\*faxNo\*/g, data[itemNum]["faxNo"])
								.replace(/\*siteUrlAddr\*/g, data[itemNum]["siteUrlAddr"])
								.replace(/\*emailAddr\*/g, data[itemNum]["emailAddr"])
								.replace(/\*wtbLatitudeValue\*/g, data[itemNum]["wtbLatitudeValue"])
								.replace(/\*wtbLongitudeValue\*/g, data[itemNum]["wtbLongitudeValue"])
								.replace(/\*brandShopFlag\*/g, data[itemNum]["brandShopFlag"])
								.replace(/\*dealerSize\*/g, data[itemNum]["dealerSize"])
								;
								//	 "distributorId":"DS05657539",
								//	 "distributorTypeCode":"STORE",
								//	 "wtbName":"北京苏宁八里庄店",
								//	 "wtbAddress":"北京市 朝阳区  八里庄东里5号楼",
								//	 "stateCode":"北京市",
								//	 "stateName":"北京市",
								//	 "stateCodeSort":1,
								//	 "cityName":"朝阳区",
								//	 "addressLine1Info":"八里庄东里5号楼",
								//	 "addressLine2Info":null,
								//	 "addressLine3Info":null,
								//	 "addressLine4Info":null,
								//	 "postalCode":null,
								//	 "wtbPhoneNo":"13681365927",
								//	 "phone2No":null,
								//	 "faxNo":null,
								//	 "siteUrlAddr":null,
								//	 "emailAddr":null,
								//	 "wtbLatitudeValue":null,
								//	 "wtbLongitudeValue":null,
								//	 "brandShopFlag":"2",
								//	 "dealerSize":null

					var $template = $(content),
						$keyBlocks = $template.find('*[data-key]');

					for (var i1 = 0; i1 < $keyBlocks.length; i1++) {
						var $currentKeyBlock = $keyBlocks.eq(i1),
							key = $currentKeyBlock.get(0).getAttribute('data-key'),
							val = data[itemNum][key];
						if(!val || val==null) {
							$currentKeyBlock.remove();
						}
					}
	
					var template = $template.get(0).outerHTML;
					self.$storeList.find('div.list').append(template);
				}
			};
			BaiduMaps.init();

			var smsModal = {
				el: document.getElementById('modal_sms_send'),
				form: document.getElementById('smsSendForm'),
				openBtn: document.querySelectorAll('[href="#modal_sms_send"]'),
				hasCaptcha: !!$('#modal_sms_send').find('#customizedCaptcha').length,
				captchaText: $('#modal_sms_send').find('#captchaCodeTextBox'),
				content: {
					$inputCon: null,
					$completeCon: null
				},
				init: function(){
					smsModal.content.$inputCon = $(smsModal.el).find('.area-form');
					smsModal.content.$completeCon = $(smsModal.el).find('.area-result');
					smsModal.addEvent();
				},
				addEvent: function(){
					$('#smsSendSubmit').on({
						click: function(e){
							e.preventDefault();
							if($(smsModal.form).checkValidation()){
								if ( smsModal.hasCaptcha ){
									if ( !!smsModal.captchaText.val() ){
										smsModal.getSmsSendResult();
									}
								} else {
									smsModal.getSmsSendResult();
								}
							}
						}
					});
					$('body').on({
						click: function(e){
							e.preventDefault();
							smsModal.currentItem = $(this).closest('.list-box').data('item');
							smsModal.resetModalContent();
							$('#modal_sms_send').modal();
						}
					}, 'a[href="#modal_sms_send"]');
				},
				resetModalContent: function(){
					smsModal.content.$completeCon.hide();
					smsModal.content.$inputCon.find("input:not([type=hidden])").val("");
					smsModal.content.$inputCon.find("input[type=checkbox]").prop('checked', false);
					smsModal.content.$inputCon.find(".field-block").removeClass("error").find(".error-msg span").hide();
					smsModal.content.$inputCon.show();
					if (!!customizedCaptcha){
						customizedCaptcha.ReloadImage();
					}
				},
				getSmsSendResult: function(){
					var resultUrl = $(smsModal.form).attr("data-result-url");
					if(!resultUrl) return false;

					var currentItem = smsModal.currentItem;
					var storeData = BaiduMaps.data[currentItem];
					var data = {
						storeName: storeData.wtbName,
						storeAddress: storeData.addressLine1Info,
						storePhone: storeData.wtbPhoneNo,
						// 20200323 START 박지영 : 오타 수정
						distributorId: storeData.distributorId,
						// 20200323 END
						userPhone: smsModal.form.txtBoxMobilePhone_sms.value,
						captcha: smsModal.form.captchaCodeTextBox.value,
						marketing: true,
						customizedCaptcha: smsModal.form.LBD_VCID_customizedCaptcha.value
					}

						console.log(data);

					// ajax
					/*
						1. captcha 확인 오류 시
						returnCode : error
						returnMessage : check-number
						( 请确认验证码 )

						2. 하루 10건 이상(1User) 발송 처리 시
						returnCode : error
						returnMessage : countlimit
						( 同一手机号当天只能收取最多10条短信 )

						3. 월 61000건 이상 발송 시
						returnCode : error
						returnMessage : totalcountlimit
						( 系统维护期间，此服务暂停使用 )

						4. 문자 발송 처리 실패 시.
						returnCode : error
						returnMessage : SMS sent fail
						( 发送失败 )

						5. 문자 발송 처리 성공 시.
						returnCode : success
						returnMessage : SMS sent successfully
						( 短信发送成功 )
					*/
					ajax.noCacheCall(resultUrl, data, 'json', function (data) {
						var doResult = function(num) {
							//$(smsModal.el)
							console.log(num);
							if(num==1) {
								smsModal.content.$inputCon.show();
								smsModal.content.$completeCon.hide();
							} else {
								smsModal.content.$inputCon.hide();
								smsModal.content.$completeCon.show();
							}
							if(num==1) {
								smsModal.content.$inputCon.find('.captcha-wrap .validationDiv').addClass('error').find('.error-msg .ajax-msg').show().siblings().hide();
							} else if (num==2) {
								smsModal.content.$completeCon.find('.send-complete .limit').show().siblings().hide();
							} else if (num==3) {
								smsModal.content.$completeCon.find('.send-complete .error').show().siblings().hide();
							} else if (num==4) {
								smsModal.content.$completeCon.find('.send-complete .fail').show().siblings().hide();
							} else if (num==5) {
								smsModal.content.$completeCon.find('.send-complete .success').show().siblings().hide();
							}
						}
						if(data) {
							var returnCode = data.data[0].returnCode;
							var returnMessage = data.data[0].returnMessage;
							if(returnCode && returnMessage) {
								console.log(returnCode, returnMessage);
								if(returnCode=='success') {
									doResult(5);
								} else {
									if(returnMessage == 'check-number') {
										doResult(1);
									} else if(returnMessage == 'countlimit') {
										doResult(2);
									} else if(returnMessage == 'totalcountlimit') {
										doResult(3);
									} else {
										doResult(4);
									}
								}
							} else {
								doResult(4);
							}
						} else {
							// error
							doResult(4);
						}

					}, 'post', 'body');

				}
			};
			if(document.getElementById('modal_sms_send')){
				smsModal.init();
			}
		};

		if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
			var mapFlag = false;
			$(window).scroll(function() {
				var t= $('.GPC0102 .find-locally-cn').eq(0).offset().top;
				var b= t + $('.GPC0102 .find-locally-cn').eq(0).height();
				if(isInScreen(t, b)) {
					if(!mapFlag) {
						loadScript();
						mapFlag = true;
					}
				}
			});
		}
	}
	//PJTGADL-2
	$('body').on('click',  '.GPC0102 .email ,.GPC0102 .phone,.GPC0102 .view-online,.GPC0102 .get-direction , .GPC0102 .box', function () {
			var className = $(this).attr('class');
			var eventName = '';
			var storeContact = '';
			var store = '';
			var suffixCode = $('.js-compare').attr('data-model-suffixcode');
			var modelCode = $('.js-compare').attr('data-model-id');
			var msrp = $('.js-compare').attr('data-msrp');
			var price = $('.js-compare').attr('data-price');
			if(price == '.' || price == '.00' || price == '0.0'){
				price = "";
			} 
			if(msrp == '.' || msrp == '.00' || msrp == '0.0'){
				msrp = "";
			} 
			if(className.indexOf('box')!=-1){
				eventName = 'buy_online_click';
				store = $(this).find('.text').text();
				dataLayer.push({
					'event'			: eventName,
					'superCategory'	: _dl.page_name.super_category,
					'category'		: standardData.level2,
					'subcategory'	: standardData.level3,
					'modelYear'		: _dl.page_name.model_year,
					'modelName'		: _dl.products[0].model_name,
					'modelCode'		: modelCode,
					'salesModelCode': _dl.products[0].sales_model_code,
					'sku'			: _dl.page_name.sku,
					'suffix'        : suffixCode,
					'store'         : store,
					'bu'            : standardData.level1,
					'price'         : price,
					'currencyCode'  : $('.currency-code').val(),
					'dimension185'  : $('.navigation').attr('data-obs-group'),
					'metric4'       : msrp,
					'pdpTop'        : 'N'
				});
			} else{
				eventName = 'find_store_click';
				store = $(this).closest('.list-text-block').find('.view-detail-map').text();
				if(className.indexOf('email')!=-1){
					storeContact = 'email';
				} else if(className.indexOf('phone')!=-1){
					storeContact =  'phone';
				} else if(className.indexOf('view-online')!=-1){
					storeContact =  'online';
				} else if(className.indexOf('get-direction')!=-1){
					storeContact =  'direction';
				}
				dataLayer.push({
					'event'			: eventName,
					'superCategory'	: _dl.page_name.super_category,
					'category'		: standardData.level2,
					'subcategory'	: standardData.level3,
					'modelYear'		: _dl.page_name.model_year,
					'modelName'		: _dl.products[0].model_name,
					'modelCode'		: modelCode,
					'salesModelCode': _dl.products[0].sales_model_code,
					'sku'			: _dl.page_name.sku,
					'suffix'        : suffixCode,
					'store'         : store,
					'storeContact'  : storeContact,
					'bu'            : standardData.level1,
					'price'         : price,
					'currencyCode'  : $('.currency-code').val(),
					'dimension185'  : $('.navigation').attr('data-obs-group'),
					'metric4'       : msrp
				});
			}
			console.log(eventName);
	});
});
